<template>
  <!-- 修改运单 -->
  <div class="contentBox">
    <!-- 基本信息 -->
    <div class="infoDiv">
      <div class="h3title">基本信息</div>
      <div class="formbox">
        <el-form :model="baseInForm" :rules="rulesBaseInform" ref="baseInFormRef" label-width="100px" class="glo_formBox">
          <div class="teSu">
            <el-form-item label="运单号:" prop="waybillNumber">
              <el-input readonly v-model="baseInForm.waybillNumber" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <!-- <el-button
              class="glo_bgcMainColor formBtns"
              @click="autoCreateNumber"
              >自动生成</el-button
            >-->
          </div>
          <el-form-item label="客户单号:" prop>
            <el-input v-model="baseInForm.customerNumber" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="客户名称:" prop="customerName">
            <el-select
              clearable
              filterable
              remote
              allow-create
              :remote-method="getCustomerList"
              default-first-option
              v-model="baseInForm.customerName"
              placeholder="请选择"
              @change="changeCustomer"
              @focus="focusCustomer"
            >
              <el-option v-for="(item, index) in CustomerLists" :key="index" :label="item.customerName" :value="item.customerName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务日期:" prop="businessDate">
            <el-date-picker v-model="baseInForm.businessDate" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="业务员:" prop="businessId">
            <el-select
              filterable
              clearable
              v-model="baseInForm.businessId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in EmployeeList"
                :key="item.documentId"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item label="业务部门:" prop="businessDeptId">
            <el-select filterable clearable v-model="baseInForm.businessDeptId" placeholder="请选择">
              <el-option v-for="item in depList" :key="item.deptId" :label="item.departmentName" :value="item.deptId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="运输方式:" prop="transportMethodConfDictId">
            <el-select filterable clearable v-model="baseInForm.transportMethodConfDictId" placeholder="请选择">
              <el-option v-for="item in transportModeList" :key="item.confDictId" :label="item.key" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提货方式:" prop="receiveMethodConfDictId">
            <el-select filterable clearable v-model="baseInForm.receiveMethodConfDictId" placeholder="请选择">
              <el-option v-for="item in ReceivingMethodList" :key="item.confDictId" :label="item.key" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="送货方式:" prop="sendMethodConfDictId">
            <el-select filterable clearable v-model="baseInForm.sendMethodConfDictId" placeholder="请选择">
              <el-option v-for="item in sendMethodList" :key="item.confDictId" :label="item.key" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否要回单:">
            <div class="glo_disFlex" style="padding-right: 3px">
              <el-select style="flex" v-model="isNeedHd" placeholder="请选择" clearable>
                <el-option v-for="item in isNeedHdList" :key="item.val" :label="item.name" :value="item.val"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item v-if="isNeedHd == '1'" label="回单要求:" prop="rnRequireConfDictId">
            <div class="glo_disFlex" style="padding-right: 3px">
              <el-select style="flex" v-model="baseInForm.rnRequireConfDictId" placeholder="请选择" filterable clearable @change="changernRequireName">
                <el-option v-for="item in rnrderRequireList" :key="item.confDictId" :label="item.key" :value="item.confDictId"></el-option>
              </el-select>
              <el-input class="miniInput" v-model="baseInForm.rnRequireCount"></el-input>份
            </div>
          </el-form-item>
          <el-form-item label="货物类型:" prop="waybillType	">
            <el-select filterable clearable v-model="baseInForm.waybillType" placeholder="请选择">
              <el-option v-for="item in waybillTypeList" :key="item.confDictId" :label="item.key" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="终端网点:" prop="endDeptId">
            <el-select v-model="baseInForm.endDeptId" placeholder="请选择">
              <el-option v-for="item in storageList" :key="item.documentId" :label="item.name" :value="item.documentId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="等通知放货">
            <el-select clearable v-model="baseInForm.isWaitNoticeSend" placeholder="请选择">
              <el-option v-for="item in yesOrNoList" :key="item.val" :label="item.name" :value="item.val + ''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提货时间:" prop="takeTime">
            <el-date-picker v-model="baseInForm.takeTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
          </el-form-item>
          <el-form-item label="交货日期:" prop="deliveryTime">
            <el-date-picker v-model="baseInForm.deliveryTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
          </el-form-item>
          <el-form-item label="是否回头货:" prop="isReturnGoods">
            <el-select clearable v-model="baseInForm.isReturnGoods" placeholder="请选择">
              <el-option v-for="item in yesOrNoList" :key="item.val" :label="item.name" :value="item.val + ''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="外发承运商:" prop="outboundCarrierId">
            <el-select filterable clearable v-model="baseInForm.carrierName" placeholder="请输入" remote :remote-method="getCarrierList" @change="changeCarrier">
              <el-option v-for="(item, index) in CarrierLists" :key="index" :label="item.carrierName" :value="item.carrierName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="textArea" style="width: 100%" label="备注:" prop="remarks">
            <el-input type="textarea" rows="2" v-model="baseInForm.remarks"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="tiHuoGuiHua">
        <div>
          <el-checkbox class="checkBoxs" v-model="isTiHuoGuiHUa">提货规划</el-checkbox>
          <el-button v-if="isTiHuoGuiHUa" class="glo_bgcMainColor saveBtns" style="margin-left: 30px" @click="guiHuaBtns">规划</el-button>
        </div>
        <!-- 提货规划 -->
        <div class="formbox" id="tiHuoForm" v-if="isTiHuoGuiHUa">
          <el-form :model="transportPlanInfoReq" ref="baseInFormRef" label-width="100px" class="glo_formBox">
            <el-form-item label="提货计划:" prop="transportPlan" style="min-width: 320px">
              <el-radio-group v-model="transportPlanInfoReq.transportPlan">
                <el-radio label="ru_cang:transport_plan">入仓</el-radio>
                <el-radio label="zhi_song:transport_plan">直送</el-radio>
                <el-radio label="wai_fa:transport_plan">外发</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="入仓仓库:" prop="customerName" v-if="
                transportPlanInfoReq.transportPlan == 'ru_cang:transport_plan'
              ">
              <el-select filterable clearable v-model="transportPlanInfoReq.storageId" placeholder="请选择" @focus="getObjectUserDownList('storage')" @change="changeStorageList">
                <el-option v-for="(item, index) in storageList" :key="index" :label="item.name" :value="item.documentId"></el-option>
              </el-select>
            </el-form-item>

            <!-- 外发 -->
            <el-form-item label="外发承运商:" prop="customerName" v-if="
                transportPlanInfoReq.transportPlan == 'wai_fa:transport_plan'
              ">
              <el-select clearable filterable v-model="transportPlanInfoReq.carrierName" placeholder="请选择" @change="changecarrierName2" @focus="getchangeCarrier()">
                <el-option v-for="item in changeCarrierList" :key="item.carrierId" :label="item.carrierName" :value="item.carrierName"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item class="queryItems" label="网点:" v-if="
                transportPlanInfoReq.transportPlan == 'wai_fa:transport_plan'
              ">
              <el-select filterable clearable v-model="transportPlanInfoReq.carrierDeptId" placeholder="请输入" @change="changeCarrierDeptName">
                <el-option v-for="(item, index) in CarrierDeptListList" :key="index" :label="item.deptName" :value="item.carrierDeptId"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item class="queryItems" label="提货方式:" v-if="
                transportPlanInfoReq.transportPlan == 'wai_fa:transport_plan'
              ">
              <el-select
                filterable
                clearable
                v-model="transportPlanInfoReq.outgoingReceiveMethodConfDictId"
                placeholder="请输入"
                @focus="getConfDictValDownList('out_going_take_method')"
                @change="changeTH"
              >
                <el-option v-for="item in OUTTakeMethodList" :key="item.confDictId" :label="item.key" :value="item.confDictId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="queryItems" label="送货方式:" v-if="
                transportPlanInfoReq.transportPlan == 'wai_fa:transport_plan'
              ">
              <el-select filterable clearable v-model="transportPlanInfoReq.outgoingSendMethodConfDictId" placeholder="请输入" @focus="getConfDictValDownList('out_going_send_method')" @change="changeSH">
                <el-option v-for="item in OUTsendMethodList" :key="item.confDictId" :label="item.key" :value="item.confDictId"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 收货信息 -->
    <div class="infoDiv">
      <div class="h3title">收货信息</div>
      <div class="formbox">
        <el-form :model="shouJiForm" :rules="rulesAddress" ref="shouJiFormRef" label-width="100px" class="glo_formBox" :disabled="isPosting">
          <el-form-item label="收货人:" prop="contacts">
            <el-input v-model="shouJiForm.contacts" placeholder="请输入" clearable></el-input>
            <!-- <el-select
              clearable
              filterable
              remote
              allow-create
              :remote-method="getCustomerList"
              default-first-option
              v-model="shouJiForm.contacts"
              placeholder="请选择"
              @change="changeCustomer2"
              @focus="focusCustomer"
            >
              <el-option
                v-for="(item, index) in CustomerLists"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>-->
          </el-form-item>
          <el-form-item label="收货单位:" prop="company">
            <el-input v-model="shouJiForm.company" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="联系电话:" prop="phone">
            <el-input v-model="shouJiForm.phone" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-button v-if="!isPosting" class="glo_bgcMainColor formBtns" @click="changeRecAddress(1)">选择收件地址</el-button>
          <el-form-item style="width: 100%; border: 0" prop="provinceName" label="收货地址:">
            <div class="disFlexs">
              <el-select class="selectAddress" v-model="shouJiForm.provinceName" placeholder="请选择省" clearable filterable @change="changeProvince">
                <el-option v-for="(item, index) in SuperiorRegionList" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
              </el-select>
              <el-select class="selectAddress" v-model="shouJiForm.cityName" placeholder="请选择市" clearable filterable @change="changeCity" @focus="getCityName(shouJiForm.provinceName)">
                <el-option v-for="(item, index) in cityNameList" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
              </el-select>
              <el-select class="selectAddress" v-model="shouJiForm.areaName" placeholder="请选择区" clearable filterable @focus="getAreaName(shouJiForm.cityName)">
                <el-option v-for="(item, index) in areaNameList" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
              </el-select>
              <el-input class="selectAddress addressDetails" v-model="shouJiForm.address" placeholder="请输入详细地址" clearable @keyup.enter.native="geocode(shouJiForm.address)"></el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 货物信息 -->
    <div class="infoDiv" id="tables">
      <div class="h3title">货物信息</div>
      <div v-for="(item, idx) in goodsInfoList" :key="idx" class="formbox goodsItmes">
        <el-form :model="item.addressReq" :rules="rulesGoods" label-width="100px" class="glo_formBox" :disabled="isPosting">
          <el-form-item label="联系人:" prop="contacts">
            <el-input v-model="item.addressReq.contacts" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="发货单位:" prop="company">
            <el-input v-model="item.addressReq.company" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="联系电话:" prop="phone">
            <el-input v-model="item.addressReq.phone" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-button v-if="!isPosting" class="glo_bgcMainColor formBtns" @click="changeRecAddress(2, idx)">选择发件地址</el-button>
          <el-form-item style="width: 100%; border: 0" label="发货地址:" prop="provinceName">
            <div class="disFlexs">
              <el-select class="selectAddress" v-model="item.addressReq.provinceName" placeholder="请选择省" clearable filterable @change="changeProvinceFH($event, idx)">
                <el-option v-for="(itemp, indexp) in SuperiorRegionList" :key="indexp" :label="itemp.districtName" :value="itemp.districtName"></el-option>
              </el-select>
              <el-select
                class="selectAddress"
                v-model="item.addressReq.cityName"
                placeholder="请选择市"
                clearable
                filterable
                @change="changeCityFH($event, idx)"
                @focus="getCityNameFH(item.addressReq.provinceName, idx)"
              >
                <el-option v-for="(itemc, indexc) in item.cityNameList" :key="indexc" :label="itemc.districtName" :value="itemc.districtName"></el-option>
              </el-select>
              <el-select class="selectAddress" v-model="item.addressReq.areaName" placeholder="请选择区" clearable filterable @focus="getAreaNameFH(item.addressReq.cityName, idx)">
                <el-option v-for="(itema, indexa) in item.areaNameList" :key="indexa" :label="itema.districtName" :value="itema.districtName"></el-option>
              </el-select>
              <el-input class="selectAddress addressDetails" v-model="item.addressReq.address" placeholder="请输入详细地址" clearable @keyup.enter.native="geocodeFH(item.addressReq.address, idx)"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="计费方式:">
            <el-select v-model="CaiWuData.formulaBillingWeightId" placeholder="请选择" clearable @change="changeBILLMethode">
              <el-option v-for="item in out_going_billing_method_list" :key="item.confDictId" :label="item.key" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="glo_Table goodsTable">
          <el-table :data="item.itemReqs" border style="width: 100%">
            <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
            <el-table-column prop="goodsNumber" label="货物编号">
              <template slot-scope="scope">
                <el-input type="text" v-model="item.itemReqs[scope.$index].goodsNumber" placeholder="请输入" :disabled="isPosting"></el-input>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="goodsName" label="*货物名称">
              <template slot-scope="scope">
                <el-input :disabled="isPosting" type="text" v-model="item.itemReqs[scope.$index].goodsName" placeholder="请输入" filterable></el-input>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="itemCategoryName" label="品类">
              <template slot-scope="scope">
                <el-select
                  :disabled="isPosting"
                  v-model="item.itemReqs[scope.$index].itemCategoryName"
                  filterable
                  clearable
                  allow-create
                  default-first-option
                  placeholder="请选择"
                  @change="changeGoodsName($event, idx)"
                >
                  <el-option v-for="(item2, index2c) in item.itemReqs[scope.$index]
                      .CategoryList" :key="index2c" :label="item2.itemCategoryName" :value="item2.itemCategoryName"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="packageName" label="包装">
              <template slot-scope="scope">
                <el-select :disabled="isPosting" v-model="item.itemReqs[scope.$index].packageName" filterable clearable default-first-option placeholder="请选择">
                  <el-option v-for="(item2, index2c) in item.itemReqs[scope.$index]
                      .packageNameList" :key="index2c" :label="item2.key" :value="item2.key"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="packageCout" label="*件数">
              <template slot-scope="scope">
                <el-input :disabled="isPosting" type="number" v-model="item.itemReqs[scope.$index].packageCout" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="grossWeight" label="*毛重">
              <template slot-scope="scope">
                <el-input :disabled="isPosting" type="text" v-model="item.itemReqs[scope.$index].grossWeight" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="netWeight" label="净重">
              <template slot-scope="scope">
                <el-input :disabled="isPosting" type="text" v-model="item.itemReqs[scope.$index].netWeight" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="volumeWeight" label="体积重量">
              <template slot-scope="scope">
                <el-input :disabled="isPosting" type="text" v-model="item.itemReqs[scope.$index].volumeWeight" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="billingWeight" label="*计费取值" width="120">
              <template slot-scope="scope">
                <el-input :disabled="isPosting" type="text" v-model="item.itemReqs[scope.$index].billingWeight" placeholder="请输入" @input="getGoodsTable(idx, scope.$index)"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="volume" label="*体积/m³">
              <template slot-scope="scope">
                <el-input :disabled="isPosting" type="text" v-model="item.itemReqs[scope.$index].volume" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="specs" label="规格">
              <template slot-scope="scope">
                <el-input :disabled="isPosting" type="text" v-model="item.itemReqs[scope.$index].specs" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="unitPrice" label="*单价">
              <template slot-scope="scope">
                <el-input :disabled="isPosting" type="text" v-model="item.itemReqs[scope.$index].unitPrice" placeholder="请输入" @input="getGoodsTable(idx, scope.$index)"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="freight" label="运费">
              <template slot-scope="scope">
                <el-input :disabled="isPosting" type="text" v-model="item.itemReqs[scope.$index].freight" placeholder="请输入" @input="getBasicFreight"></el-input>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" v-if="!isPosting">
              <template slot-scope="scope">
                <div class="iconList">
                  <i v-if="item.itemReqs.length == scope.$index + 1" class="el-icon-circle-plus iconSize" @click="AddGoods(idx, scope.$index)"></i>
                  <el-popconfirm v-if="item.itemReqs.length > 1" title="确定删除该行数据吗" @confirm="delGoods(idx, scope.$index)">
                    <i slot="reference" class="el-icon-remove iconSize"></i>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="!isPosting">
          <div class="addTiHuoDiZhi" v-if="goodsInfoList.length > 1">
            <el-popconfirm title="确定删除该提货地址吗" @confirm="delDiZhi(idx)">
              <el-button slot="reference" style="margin-top: 20px" class="formBtns">删除提货地址</el-button>
            </el-popconfirm>
          </div>
        </div>
      </div>

      <div class="addTiHuoDiZhi" v-if="!isPosting">
        <el-button @click="addDiZhi" class="glo_bgcMainColor formBtns">添加提货地址</el-button>
      </div>
    </div>
    <!-- 财务应收 -->
    <div class="infoDiv">
      <div class="h3title">财务应收</div>
      <div class="formbox">
        <el-form :model="CaiWuData" :rules="rulesYS" ref="CaiWuDataRef" label-width="100px" class="glo_formBox" :disabled="isPosting">
          <el-form-item label="基本运费:" prop="basicFreight">
            <div class="disFlexs jsInput">
              <el-input v-model="CaiWuData.basicFreight" placeholder="请输入" clearable type="number" @input="getTotalFreight()"></el-input>
              <el-button class="jsBtns glo_bgcMainColor" @click="getBasicFreight()" v-if="!isPosting">计算</el-button>
            </div>
          </el-form-item>
          <el-form-item label="提货费:" prop="takeFee">
            <el-input v-model="CaiWuData.takeFee" placeholder="请输入" clearable type="number" @input="getTotalFreight()"></el-input>
          </el-form-item>
          <el-form-item label="送货费:" prop="sendFee">
            <el-input v-model="CaiWuData.sendFee" placeholder="请输入" clearable type="number" @input="getTotalFreight()"></el-input>
          </el-form-item>
          <el-form-item label="装卸费:" prop="unLoadFee">
            <el-input v-model="CaiWuData.unLoadFee" placeholder="请输入" clearable type="number" @input="getTotalFreight()"></el-input>
          </el-form-item>
          <el-form-item label="保险费:" prop="insuranceFee">
            <el-input v-model="CaiWuData.insuranceFee" placeholder="请输入" clearable type="number" @input="getTotalFreight()"></el-input>
          </el-form-item>
          <el-form-item label="其他费用:" prop="allOtherFee">
            <div class="disFlexs jsInput">
              <el-input v-model="CaiWuData.allOtherFee" placeholder="请输入" clearable type="number" @input="getTotalFreight()"></el-input>
              <el-button class="jsBtns glo_bgcMainColor" @click="getOtherExpenses()" v-if="!isPosting">计算</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="glo_Table" style="margin-bottom: 20px">
        <el-button v-if="!isPosting" class="glo_bgcMainColor" style="margin-bottom: 10px" @click="AddFeiXian">添加应收费项</el-button>
        <el-table ref="ysTable" :data="CaiWuData.itemServiceReqs" show-summary border style="width: 100%">
          <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
          <el-table-column align="center" prop="itemServiceName" label="费项"></el-table-column>
          <el-table-column align="center" prop="itemCategoryName" label="费项类型"></el-table-column>
          <el-table-column align="center" prop="amount" label="金额"></el-table-column>
          <el-table-column align="center" prop="remarks" label="备注"></el-table-column>
          <el-table-column fixed="right" label="操作" v-if="!isPosting">
            <template slot-scope="scope">
              <div class="iconList">
                <el-button class="tbBtns" @click="editFeiXian(scope.row, scope.$index)">编辑</el-button>

                <el-popconfirm title="确定删除该行数据吗" @confirm="delFeiXian(scope.$index)">
                  <el-button slot="reference" class="tbBtns">删除</el-button>
                  <!-- <i slot="reference" class="el-icon-remove iconSize"></i> -->
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="formbox">
        <el-form :model="CaiWuData" :rules="rulesCaiWu" ref="CaiWuData" label-width="100px" class="glo_formBox" :disabled="isPosting">
          <el-form-item label="运费合计:" prop="totalFreight">
            <div class="disFlexs jsInput">
              <el-input v-model="CaiWuData.totalFreight" placeholder="请输入" clearable type="number"></el-input>
              <el-button class="jsBtns glo_bgcMainColor" @click="getTotalFreight()" v-if="!isPosting">计算</el-button>
            </div>
          </el-form-item>
          <el-form-item label="是否开票:" prop="isInvoice">
            <el-select filterable clearable v-model="CaiWuData.isInvoice" placeholder="请选择">
              <el-option v-for="item in yesOrNoList" :key="item.val" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票税点:" prop="invoiceTaxPoint">
            <div class="disFlex">
              <el-input v-model="CaiWuData.invoiceTaxPoint" placeholder="请输入" clearable type="number" @input="getTaxes()"></el-input>
              <div>(%)</div>
            </div>
          </el-form-item>
          <el-form-item label="税金:" prop="taxes">
            <div class="disFlexs jsInput">
              <el-input v-model="CaiWuData.taxes" placeholder="请输入" clearable type="number"></el-input>
              <el-button class="jsBtns glo_bgcMainColor" @click="getTaxes()" v-if="!isPosting">计算</el-button>
            </div>
          </el-form-item>
          <el-form-item label="开单金额:" prop="billingAmount">
            <div class="disFlexs jsInput">
              <el-input v-model="CaiWuData.billingAmount" placeholder="请输入" clearable type="number" min="0"></el-input>
              <el-button class="jsBtns glo_bgcMainColor" @click="getBillingAmount()" v-if="!isPosting">计算</el-button>
            </div>
          </el-form-item>
          <el-form-item label="代收货款:" prop="agentAmount">
            <el-input v-model="CaiWuData.agentAmount" placeholder="请输入" clearable type="number"></el-input>
          </el-form-item>
          <el-form-item label="结算方式:" prop="settlementMethodConfDictId">
            <el-select filterable clearable v-model="CaiWuData.settlementMethodConfDictId" placeholder="请选择" @change="changeSettlementMethod">
              <el-option v-for="item in settlementMethodList" :key="item.confDictId" :label="item.val" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="寄付金额:" prop="senderAmount	">
            <el-input v-model="CaiWuData.senderAmount" placeholder="请输入" :disabled="amountIsAble" type="number"></el-input>
          </el-form-item>
          <el-form-item label="到付金额:" prop="receivedAmount">
            <el-input v-model="CaiWuData.receivedAmount" placeholder="请输入" :disabled="amountIsAble" type="number"></el-input>
          </el-form-item>
          <el-form-item label="月结金额:" prop="monthlyAmount">
            <el-input v-model="CaiWuData.monthlyAmount" placeholder="请输入" :disabled="amountIsAble" type="number"></el-input>
          </el-form-item>
          <el-form-item label="回单结金额:" prop="rnorderAmount">
            <el-input v-model="CaiWuData.rnorderAmount" placeholder="请输入" :disabled="amountIsAble" type="number"></el-input>
          </el-form-item>
          <el-form-item label="货款扣运费:" prop="goodsDeductedAmoun">
            <el-input v-model="CaiWuData.goodsDeductedAmoun" placeholder="请输入" :disabled="amountIsAble" type="number"></el-input>
          </el-form-item>

          <el-form-item class="textArea" style="width: 100%" label="费项说明:" prop="remarks">
            <el-input type="textarea" rows="2" v-model="CaiWuData.remarks"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 财务应付 -->
    <div class="infoDiv">
      <div class="h3title">财务应付</div>
      <div class="glo_Table" style="margin-bottom: 20px">
        <el-button v-if="!isPosting" class="glo_bgcMainColor" style="margin-bottom: 10px" @click="addYinFu">添加应付</el-button>
        <el-table show-summary :data="financeOutInfoReqs" border style="width: 100%">
          <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
          <el-table-column align="center" prop="itemServiceName" label="费项"></el-table-column>
          <el-table-column align="center" prop="amount" label="金额"></el-table-column>
          <el-table-column align="center" prop="objectName" label="结算对象"></el-table-column>
          <el-table-column align="center" prop="paymentMethod" label="付款方式"></el-table-column>
          <el-table-column align="center" prop="remarks" label="备注"></el-table-column>
          <el-table-column fixed="right" prop="cccc" label="操作" v-if="!isPosting">
            <template slot-scope="scope">
              <div class="iconList">
                <el-button class="tbBtns" @click="EditFeiXian(scope.row, scope.$index)">编辑</el-button>
                <el-popconfirm title="确定删除该行数据吗" @confirm="delFeiXian2(scope.$index)">
                  <el-button slot="reference" class="tbBtns">删除</el-button>
                  <!-- <i slot="reference" class="el-icon-remove iconSize"></i> -->
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 运单图片 -->
    <div class="infoDiv">
      <div class="h3title">运单图片</div>
      <div>
        <div style="margin-bottom: 10px">上传图片: (支持上传jpg/png文件)</div>
        <uploadimgs @input="changeFileList" :fileNameLists="fileNameLists" :limit="9"></uploadimgs>
      </div>
    </div>

    <!-- 最后按钮 -->
    <div class="btmBtns">
      <el-button class="glo_bgcMainColor saveBtns" @click="submit">保 存</el-button>
    </div>

    <!-- 弹窗 添加应收 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form class="diaForm" v-if="isShowDialog" ref="dialogFormRef" :model="dialogForm" label-width="100px" :rules="rulesForm">
          <el-form-item class="dialogFormItems" prop="itemCategoryId" label="费项类型:">
            <el-select filterable clearable v-model="dialogForm.itemCategoryId" placeholder="请选择" @change="changeItemCategoryId">
              <el-option v-for="(item, index) in categoryNameList" :key="index" :label="item.categoryName" :value="item.categoryId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="itemServiceId" label="费项:">
            <el-select filterable clearable v-model="dialogForm.itemServiceId" placeholder="请选择" @change="changeItemServiceId">
              <el-option v-for="(item, index) in CategoryServiceList" :key="index" :label="item.title" :value="item.itemServiceId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="amount" label="金额:">
            <el-input v-model="dialogForm.amount"></el-input>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input type="textarea" rows="2" v-model="dialogForm.remarks"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 弹窗 添加应付 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="diaCancelBtn2"
      @diaConfirmBtn="diaConfirmBtn2('dialogForm2Ref')"
    >
      <div class="glo_dialogForm">
        <el-form class="diaForm" ref="dialogForm2Ref" v-if="isShowDialog2" :model="dialogForm2" label-width="100px" :rules="rulesForm2">
          <el-form-item class="dialogFormItems" prop="inoutStatus" label="收支类型:">
            <el-select filterable clearable v-model="dialogForm2.inoutStatus" placeholder="请选择" disabled>
              <el-option v-for="(item, index) in inoutStatusList" :key="index" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width: 500px" class="dialogFormItems" prop="objectStatusType" label="结算对象:">
            <div class="multipleSelect">
              <el-select filterable clearable v-model="dialogForm2.objectStatusType" placeholder="请选择" @change="changeObjestStatus">
                <el-option v-for="(item, index) in objectStatusList" :key="index" :label="item.val" :value="item.key"></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                v-model="dialogForm2.objectName"
                placeholder="请选择"
                remote
                :allow-create="dialogForm2.objectStatusType == 'other'"
                :remote-method="getObjectUserDownListYf"
                @change="changeobjectName"
              >
                <el-option v-for="(item, index) in CustomerListsYF" :key="index" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item style="width: 500px" class="dialogFormItems" prop="itemCategoryId" label="费项:">
            <div class="multipleSelect">
              <el-select filterable clearable v-model="dialogForm2.itemCategoryId" placeholder="请选择" @change="changeItemCategoryIdYF">
                <el-option v-for="(item, index) in categoryNameList" :key="index" :label="item.categoryName" :value="item.categoryId"></el-option>
              </el-select>
              <el-select allow-create filterable clearable v-model="dialogForm2.itemServiceId" placeholder="请选择" @change="changeItemServiceId2">
                <el-option v-for="(item, index) in CategoryServiceList" :key="index" :label="item.title" :value="item.itemServiceId"></el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="amount" label="金额:">
            <el-input v-model="dialogForm2.amount" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="paymentMethodConfDictId" label="付款方式:">
            <el-select filterable clearable v-model="dialogForm2.paymentMethodConfDictId" placeholder="请选择" @change="changePayMent">
              <el-option v-for="(item, index) in settlementMethodList" :key="index" :label="item.val" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input type="textarea" rows="2" v-model="dialogForm2.remarks"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 弹窗 收件人地址 -->
    <myDialog
      :diaWidth="diaWidth3"
      :dialogTitle="dialogTitle3"
      :isShowDialog="isShowDialog3"
      :showConfirm="false"
      @handleCloseDia="handleCloseDia3"
      @diaCancelBtn="handleCloseDia3"
      @diaConfirmBtn="diaConfirmBtn3"
    >
      <div class="glo_dialogForm">
        <!-- 查询条件 -->
        <div ref="queryForm">
          <el-form :model="queryData" class="glo_form" label-position="left">
            <!-- <el-form-item class="queryItems" label="联系人:">
              <el-select
                clearable
                filterable
                remote
                :remote-method="getCustomerListAddress"
                default-first-option
                v-model="queryData.customerId"
                placeholder="请选择"
                @change="changecustomerId"
                disabled
              >
                <el-option
                  v-for="item in addressNaemList"
                  :key="item.customerId"
                  :label="item.customerName"
                  :value="item.customerId"
                ></el-option>
              </el-select>
            </el-form-item>-->
            <!-- <el-form-item class="queryItems" label="收发类型:">
              <el-select
                filterable
                clearable
                v-model="queryData.addressType"
                placeholder="请输入"
                disabled
              >
                <el-option
                  label="发件"
                  value="ji_jian:address_type"
                ></el-option>
                <el-option
                  label="收件"
                  value="shou_jian:address_type"
                ></el-option>
              </el-select>
            </el-form-item>-->
            <el-form-item class="queryItems" label="发货单位:">
              <el-input clearable v-model="queryData.deptName" placeholder="请输入" @keyup.enter.native="getCustomerAddrList()"></el-input>
            </el-form-item>
            <el-form-item class="queryItems" label="联系人:">
              <el-input clearable v-model="queryData.personnelName" placeholder="请输入" @keyup.enter.native="getCustomerAddrList()"></el-input>
            </el-form-item>
            <!-- <el-form-item class="queryItems" label="联系电话:">
              <el-input
                clearable
                v-model="queryData.personnelName"
                placeholder="请输入"
                @keyup.enter.native="getCustomerAddrList()"
              ></el-input>
            </el-form-item>-->
            <el-button class="glo_btnItems glo_bgcMainColor" @click="getCustomerAddrList">查询</el-button>
          </el-form>
        </div>
        <div class="glo_Table">
          <el-table header-align="center" ref="mytable" @row-click="rowclick" :data="tableData" border stripe @selection-change="handleSelectionChange">
            <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
            <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
            <template v-for="(item, index) in addressTableHeard">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
            <el-table-column fixed="right" label="操作" min-width="100px">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button class="rbtns" @click.stop="changeAddress(scope.row)">选择</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </myDialog>
    <!-- 弹窗 规划 -->
    <myDialog
      :diaWidth="diaWidth_gh"
      :dialogTitle="dialogTitle_gh"
      :isShowDialog="isShowDialog_gh"
      :showConfirm="false"
      @handleCloseDia="handleCloseDia_gh"
      @diaCancelBtn="handleCloseDia_gh"
      @diaConfirmBtn="diaConfirmBtn_gh"
    >
      <div class="glo_dialogForm">
        <el-button v-if="createTaskDatas.length == 0" @click="addTaskData" class="btns addBtns" type="primary">新增提货任务</el-button>
        <div class="renwuList" v-for="(item, idx) in createTaskDatas" :key="idx">
          <el-button class="btns" v-if="item.transportType == 'ti_huo:transport_type'">提货</el-button>
          <el-button class="btns" v-else>仓配</el-button>
          <div class="rightBox">
            <div>
              <el-form :model="item" ref="baseInFormRef" label-width="100px" class="glo_formBox">
                <el-form-item v-if="item.transportType !== 'ti_huo:transport_type'" label="仓配类型:" prop="transportType" style="width: 100%">
                  <el-radio-group v-model="item.transportType">
                    <el-radio label="nei_bu_cang_pei_song:transport_type">内部仓配送</el-radio>
                    <el-radio label="wai_bu_cang_pei_song:transport_type">外部仓配送</el-radio>
                  </el-radio-group>
                </el-form-item>
                <!-- 外部承运才显示 -->
                <el-form-item label="外部承运商:" v-if="
                    item.transportType == 'wai_bu_cang_pei_song:transport_type'
                  ">
                  <el-select clearable filterable v-model="item.externalCarrierName" placeholder="请选择" @change="changecarrierName2GH_wb($event, idx)">
                    <el-option v-for="itemE in changeCarrierListGH" :key="itemE.carrierId" :label="itemE.carrierName" :value="itemE.carrierName"></el-option>
                  </el-select>
                </el-form-item>
                <!-- 外部承运商网点 -->
                <el-form-item label="外部仓网点:" prop="customerName" v-if="
                    item.transportType == 'wai_bu_cang_pei_song:transport_type'
                  ">
                  <el-select clearable filterable v-model="item.wbcarrierDeptId" placeholder="请选择" @change="changeWBWD($event, idx)">
                    <el-option v-for="itema in item.wbDepList" :key="itema.carrierDeptId" :label="itema.deptName" :value="itema.carrierDeptId"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="提货计划:" prop="transportPlan" style="width: 100%">
                  <el-radio-group v-model="item.transportPlan">
                    <el-radio label="zhi_song:transport_plan">直送</el-radio>
                    <el-radio label="wai_fa:transport_plan">外发</el-radio>
                    <el-radio label="ru_cang:transport_plan">入仓</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="入仓仓库:" prop="customerName" v-if="item.transportPlan == 'ru_cang:transport_plan'">
                  <el-select filterable clearable v-model="item.storageId" placeholder="请选择" @focus="getObjectUserDownListGH('storage')" @change="changeStorageListGH($event, idx)">
                    <el-option v-for="itemb in storageListGH" :key="itemb.documentId" :label="itemb.name" :value="itemb.documentId"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="配送仓库:" prop v-if="
                    item.transportType == 'nei_bu_cang_pei_song:transport_type'
                  ">
                  <el-select filterable clearable v-model="item.PSstorageId" placeholder="请选择" @focus="getObjectUserDownListGH('storage')" @change="changeStorageListGH_nb($event, idx)">
                    <el-option v-for="itemb in storageListGH" :key="itemb.documentId" :label="itemb.name" :value="itemb.documentId"></el-option>
                  </el-select>
                </el-form-item>

                <!-- 外发 -->
                <el-form-item label="外发承运商:" prop="customerName" v-if="item.transportPlan == 'wai_fa:transport_plan'">
                  <el-select clearable filterable v-model="item.carrierName" placeholder="请选择" @change="changecarrierName2GH($event, idx)">
                    <el-option v-for="itemc in changeCarrierListGH" :key="itemc.carrierId" :label="itemc.carrierName" :value="itemc.carrierName"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item class="queryItems" label="网点:" v-if="item.transportPlan == 'wai_fa:transport_plan'">
                  <el-select filterable clearable v-model="item.carrierDeptId" placeholder="请输入">
                    <el-option v-for="itemd in item.CarrierDeptListListGH" :key="itemd.carrierDeptId" :label="itemd.deptName" :value="itemd.carrierDeptId"></el-option>
                  </el-select>
                </el-form-item>

                <!-- <el-form-item
                class="queryItems"
                label="提货方式:"
                v-if="
                  item.transportPlan ==
                  'wai_fa:transport_plan'
                "
              >
                <el-select
                  filterable
                  clearable
                  v-model="createTaskDatas.outgoingReceiveMethodConfDictId"
                  placeholder="请输入"
                  @focus="getConfDictValDownList('receive_method')"
                  @change="changeTH"
                >
                  <el-option
                    v-for="(item, index) in ReceivingMethodList"
                    :key="index"
                    :label="item.key"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
                </el-form-item>-->
                <!-- <el-form-item
                class="queryItems"
                label="送货方式:"
                v-if="
                  item.transportPlan ==
                  'wai_fa:transport_plan'
                "
              >
                <el-select
                  filterable
                  clearable
                  v-model="createTaskDatas.outgoingSendMethodConfDictId"
                  placeholder="请输入"
                  @focus="getConfDictValDownList('send_method')"
                  @change="changeSH"
                >
                  <el-option
                    v-for="(item, index) in sendMethodList"
                    :key="index"
                    :label="item.key"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
                </el-form-item>-->

                <el-form-item style="width: 100%; border: 0" label="目的地址:" prop="provinceName">
                  <div class="disFlexs">
                    <el-select class="selectAddress" v-model="item.provinceName" placeholder="请选择省" clearable filterable @change="changeProvinceGh($event, idx)">
                      <el-option v-for="(itemp, indexp) in SuperiorRegionList" :key="indexp" :label="itemp.districtName" :value="itemp.districtName"></el-option>
                    </el-select>
                    <el-select class="selectAddress" v-model="item.cityName" placeholder="请选择市" clearable filterable @change="changeCityGH($event, idx)" @focus="getCityNameGH(item.provinceName, idx)">
                      <el-option v-for="itemcc in item.cityNameList" :key="itemcc.districtName" :label="itemcc.districtName" :value="itemcc.districtName"></el-option>
                    </el-select>
                    <el-select class="selectAddress" v-model="item.areaName" placeholder="请选择区" clearable filterable @focus="getAreaNameGH(item.cityName, idx)">
                      <el-option v-for="(itemaa, indexaa) in item.areaNameList" :key="indexaa" :label="itemaa.districtName" :value="itemaa.districtName"></el-option>
                    </el-select>
                    <el-input class="selectAddress addressDetails" v-model="item.address" placeholder="请输入详细地址" clearable @keyup.enter.native="geocode_guihua(item.address, idx)"></el-input>
                  </div>
                </el-form-item>

                <el-form-item class="textArea" style="width: 100%" label="备注:" prop="remarks">
                  <el-input type="textarea" rows="2" v-model="item.remarks"></el-input>
                </el-form-item>
              </el-form>

              <el-button v-if="!item.taskIds || item.taskIds.length == 0" class="btns addBtns" @click="saveRenWu(idx)" type="primary">保存</el-button>
              <el-button v-if="item.taskIds && item.taskIds.length > 0" class="btns addBtns" @click="wtl_delTask(idx)" type="warning">删除</el-button>
            </div>
          </div>
        </div>
      </div>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
export default {
  inject: ["reload"],
  components: {
    myDialog,
    uploadimgs,
  },
  data() {
    return {
      out_going_billing_method_list: [],
      amountIsAble: true,
      CarrierLists: [],
      SuperiorRegionList: [], //省
      cityNameList: [], //市
      areaNameList: [], //区
      baseInForm: {
        businessDate: "", //业务日期
        businessDeptId: "", //业务部门id
        businessId: "", //业务员id(员工表id)
        customerId: "", //客户id
        customerName: "", //客户名称
        customerNumber: "", //客户单号
        deliveryTime: "", //交货日期
        endDeptId: "", //终端网点id
        isReturnGoods: "0", //是否回头货 0=否 1=是
        isWaitNoticeSend: "0", //等通知放货 0=否 1=是
        outboundCarrierId: "", //外发承运商id
        receiveMethodConfDictId: "", //收货方式id(字典表id)
        remarks: "", //备注
        rnRequireConfDictId: "", //回单要求id
        rnRequireCount: "", //回单份数
        rnRequireName: "", //回单要求
        sendMethodConfDictId: "", //送货方式id(字典表id)
        takeTime: "", //提货时间
        transportMethodConfDictId: "", //运输方式id(字典表id)
        waybillNumber: "", //运单号
        waybillType: "", //货物类型: kuai_jian:waybill_type=快件 pu_jian:waybill_type=普件
        carrierName: "", //外发承运商
      },
      // 收件信息
      shouJiForm: {
        address: "",
        addressType: "shou:address_type",
        areaName: "",
        cityName: "",
        company: "",
        contacts: "",
        phone: "",
        provinceName: "",
        serialNumber: "1",
        tel: "",
      },
      // 财务应收
      CaiWuData: {
        agentAmount: "",
        allOtherFee: "",
        basicFreight: "",
        billingAmount: "",
        goodsDeductedAmoun: "",
        insuranceFee: "",
        invoiceTaxPoint: "",
        isInvoice: "0",
        monthlyAmount: "",
        receivedAmount: "",
        remarks: "",
        rnorderAmount: "",
        sendFee: "",
        senderAmount: "",
        settlementMethodConfDictId: "",
        takeFee: "",
        taxes: "",
        totalFreight: "",
        unLoadFee: "",
        itemServiceReqs: [],
        formulaBillingWeightId: "",
      },
      types: "",
      //基本信息
      rulesBaseInform: {
        businessDate: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        businessDeptId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        // businessId: [
        //   { required: true, message: "请选择", trigger: ["blur", "change"] },
        // ],
        customerId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        customerName: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        customerNumber: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        deliveryTime: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        endDeptId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        isReturnGoods: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        isWaitNoticeSend: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        receiveMethodConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        sendMethodConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        takeTime: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        transportMethodConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        waybillNumber: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        waybillType: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        rnRequireConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },

      rulesGoods: {
        areaName: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        cityName: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        contacts: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        phone: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        provinceName: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },

      rulesYS: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      rulesCaiWu: {
        settlementMethodConfDictId: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      rules: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // 收件地址信息
      rulesAddress: {
        addressType: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        areaName: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        cityName: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        provinceName: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        // company: [
        //   { required: true, message: "请输入", trigger: ["blur", "change"] },
        // ],
        contacts: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        phone: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      isZDYCustomer: false, //是否是自定义客户名称
      CustomerLists: [], //客户列表
      CustomerListsYF: [], //对象列表
      addressNaemList: [], //客户档案列表
      EmployeeList: [], //员工列表
      depList: [], //部门列表
      storageList: [], //网点列表
      transportModeList: [], //运输方式
      ReceivingMethodList: [], //提货方式
      sendMethodList: [], //送货方式
      rnrderRequireList: [], //回单类型
      waybillTypeList: [], //货物类型
      objectStatusList: [], //结算对象类型
      settlementMethodList: [], //付款方式
      CustomerList: [], //

      goodsInfoList: [
        {
          addressReq: {
            address: "",
            addressType: "",
            areaName: "",
            cityName: "",
            company: "",
            contacts: "",
            phone: "",
            provinceName: "",
            serialNumber: "",
            tel: "",
          },
          itemReqs: [
            {
              billingWeight: "",
              freight: "",
              goodsName: "",
              goodsNumber: "",
              grossWeight: "",
              itemCategoryCode: "",
              itemCategoryName: "",
              netWeight: "",
              packageCout: "",
              packageName: "",
              serialNumber: "",
              specs: "",
              unitPrice: "",
              volume: "",
              volumeWeight: "",
              CategoryList: [], //
              packageNameList: [], //
            },
          ],
          DelitemReqs: [], //已删除的货物
        },
      ],
      // 财务应付
      financeOutInfoReqs: [], // 应付表格
      CaiWuFeiXiang: [],
      // 弹窗===添加应收
      isShowDialog: false,
      dialogTitle: "",
      dialogType: "add",
      deitIdx: 0,
      diaWidth: "40%",
      dialogForm: {
        // 弹窗表单数据
        amount: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        remarks: "",
      },

      rulesForm: {
        itemCategoryId: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        itemServiceId: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        amount: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // 弹窗===添加应付
      isShowDialog2: false,
      dialogTitle2: "",
      dialogType2: "",
      editYfIdx: 0,
      diaWidth2: "40%",
      dialogForm2: {
        // 弹窗表单数据
        amount: "",
        inoutStatus: "zhi_chu:deal_status",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        paymentMethodConfDictId: "",
        remarks: "",
        objectStatusType: "", //对象类型(我自己加的)
        paymentMethod: "", //付款方式名称(我自己加的)
        objectStatus: "", //(我自己加的)
      },
      rulesForm2: {
        itemCategoryId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        itemServiceId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        objectStatusType: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        objectName: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        paymentMethodConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        amount: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      isShowDialog_gh: false,
      dialogTitle_gh: "",
      diaWidth_gh: "80%",
      // 地址弹窗
      addressIdx: 0,
      isShowDialog3: false,
      dialogTitle3: "",
      diaWidth3: "80%",
      tableData: [],
      addressTableHeard: [
        {
          name: "发货单位",
          field: "deptName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "联系人",
          field: "personnelName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "联系电话",
          field: "tel",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        // {
        //   name: "所属网点",
        //   field: "deptName",
        //   width: "120",
        //   sort: 3,
        //   isShow: true, //是否展示
        //   isTotal: false, //是否开启合计
        //   isSort: true, //表格设置里面是否可以排序
        // },
        {
          name: "省份",
          field: "provinceName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "城市",
          field: "cityName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "区县",
          field: "areaName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "详细地址",
          field: "address",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "备注",
          field: "remarks",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],

      queryData: {
        customerId: "",
        addressType: "",
        deptName: "",
        personnelName: "",
      },

      fileVoListAll: [], //初始图片
      fileNameLists: [], //显示图片,可以修改
      CategoryList: [],
      packageNameList: [],
      selectTableData: [],
      yesOrNoList: [
        {
          name: "是",
          val: 1,
        },
        {
          name: "否",
          val: 0,
        },
      ],
      inoutStatusList: [
        {
          name: "收入",
          val: "shou_ru:deal_status",
        },
        {
          name: "支出",
          val: "zhi_chu:deal_status",
        },
      ],

      categoryNameList: [], //费项类型
      CategoryServiceList: [], //费项
      waybillSplitId: "",

      isPosting: false, //是否已过账
      DelGOodsInfoList: [], //已删除的提货地址
      delItemServiceReqs2: [],
      contactsId: "", //收件人id，已弃用

      isNeedHd: "1",
      isNeedHdList: [
        {
          name: "需要",
          val: "1",
        },
        {
          name: "不需要",
          val: "0",
        },
      ],

      isTiHuoGuiHUa: true, //是否提货规划

      //提货信息
      transportPlanInfoReq: {
        carrierDeptId: "",
        carrierDeptName: "",
        carrierId: "",
        carrierName: "",
        outgoingReceiveMethod: "",
        outgoingReceiveMethodConfDictId: "",
        outgoingSendMethod: "",
        outgoingSendMethodConfDictId: "",
        storageId: "",
        storageName: "",
        transportPlan: "ru_cang:transport_plan",
      },

      CarrierDeptListList: [],
      CarrierDeptListListGH: [],
      changeCarrierList: [],
      changeCarrierListGH: [],

      createTaskDatas: [],
      storageListGH: [],

      OUTsendMethodList: [], //
      OUTTakeMethodList: [], //
    };
  },
  watch: {
    // 监听基本运费
    "CaiWuData.basicFreight": function (a, b) {
      // 重新计算合计运费
      this.getTotalFreight();
    },
    // 监听合计运费
    "CaiWuData.totalFreight": function (a, b) {
      // 合计运费变化,重新计算税金
      this.getTaxes();
      // 合计运费变化,重新计算开单金额
      this.getBillingAmount();
    },
    // 监听税金
    "CaiWuData.taxes": function (a, b) {
      // 税金变化,重新开单金额
      this.getBillingAmount();
    },
    // 监听其他费用
    "CaiWuData.allOtherFee": function (a, b) {
      // 重新计算合计运费
      this.getTotalFreight();
    },
    // 监听开单金额变化，根据付款方式计算
    "CaiWuData.billingAmount": function (a, b) {
      // 重新计算合计运费
      this.changeSettlementMethod(this.CaiWuData.settlementMethodConfDictId);
    },
    isTiHuoGuiHUa: function (a, b) {
      if (!a) {
        this.transportPlanInfoReq = {
          carrierDeptId: "",
          carrierDeptName: "",
          carrierId: "",
          carrierName: "",
          outgoingReceiveMethod: "",
          outgoingReceiveMethodConfDictId: "",
          outgoingSendMethod: "",
          outgoingSendMethodConfDictId: "",
          storageId: "",
          storageName: "",
          transportPlan: "",
        };
      }
    },

    goodsInfoList: {
      handler(a, b) {
        console.log("aaaabb", a);
        console.log("types", this.types);
        a.forEach((item) => {
          item.itemReqs.forEach((item2) => {
            if (this.types == "按毛重") {
              if (item2.grossWeight) {
                item2.billingWeight = item2.grossWeight;
              }
            }
            if (this.types == "按毛重") {
              if (item2.grossWeight) {
                item2.billingWeight = item2.grossWeight;
              }
            }
            if (this.types == "按净重") {
              if (item2.netWeight) {
                item2.billingWeight = item2.netWeight;
              }
            }
            if (this.types == "按件数") {
              if (item2.packageCout) {
                item2.billingWeight = item2.packageCout;
              }
            }
            if (this.types == "按体积") {
              if (item2.volume) {
                item2.billingWeight = item2.volume;
              }
            }
          });
        });
      },
      deep: true,
    },
  },
  created() {
    this.getCategoryList(); // 获取品类
    this.getCustomerList(); //  获取客户列表
    this.getDeptList();

    // 根据对象类型获取结算对象的下拉列表
    this.getObjectUserDownList("employee"); //获取员工列表
    // this.getObjectUserDownList("dept"); //获取部门列表
    this.getObjectUserDownList("storage"); //获取网点列表

    // 根据字典类型获取字典值下拉列表
    this.getConfDictValDownList("package_name"); //获取包装
    this.getConfDictValDownList("waybill_type"); //货物类型
    this.getConfDictValDownList("rn_order_require"); //回单类型
    this.getConfDictValDownList("send_method"); //送货方式
    this.getConfDictValDownList("receive_method"); //提货方式
    this.getConfDictValDownList("transport_method"); //运输方式
    this.getConfDictValDownList("settlement_method"); //付款方式
    // this.getConfDictValDownList("out_going_take_method"); //外发提货方式
    // this.getConfDictValDownList("out_going_send_method"); //外发送货方式
    // this.getConfDictValDownList("out_going_billing_method"); //计费方式
  },
  mounted() {
    this.getParentName("中华人民共和国"); //默认查到各省
    this.getCarrierList(); // 获取承运商列表
  },
  activated() {
    // this.baseInForm.businessDate = this.$TOOLS.getCurrentTime();
    // this.baseInForm.takeTime = this.$TOOLS.getCurrentTime();

    let waybillSplitId = this.$route.query.waybillSplitId || "";

    if (waybillSplitId) {
      this.waybillSplitId = waybillSplitId;
      this.getPackageDetails(); //  获取运单详情
      this.getWaybillFinance(); // 获取运单财务信息
    }
  },
  destroyed() {},
  methods: {
    // 选择计费方式自动填充计费取值
    changeBILLMethode(e) {
      if (e) {
        this.out_going_billing_method_list.forEach((item) => {
          if (item.confDictId == e) {
            let types = item.key;
            this.types = types; //外发计费方式
            let datas = JSON.parse(JSON.stringify(this.goodsInfoList));
            datas.forEach((item) => {
              item.itemReqs.forEach((item2, index) => {
                if (types == "按毛重") {
                  if (item2.grossWeight) {
                    item2.billingWeight = item2.grossWeight;
                  }
                }
                if (types == "按毛重") {
                  if (item2.grossWeight) {
                    item2.billingWeight = item2.grossWeight;
                  }
                }
                if (types == "按净重") {
                  if (item2.netWeight) {
                    item2.billingWeight = item2.netWeight;
                  }
                }
                if (types == "按件数") {
                  if (item2.packageCout) {
                    item2.billingWeight = item2.packageCout;
                  }
                }
                if (types == "按体积") {
                  if (item2.volume) {
                    item2.billingWeight = item2.volume;
                  }
                }
              });
            });

            this.goodsInfoList = datas;
          }
        });
      }
    },

    geocode_guihua(getAddress, idx) {
      if (!getAddress) {
        return false;
      }
      let param = {
        address: getAddress || "",
        city: "",
      };
      this.$API.geocode(param).then((res) => {
        let result = res.data.result.geocodes || [];
        if (result.length == 0) {
          return false;
        }
        let datas = result[0] || "";
        let val = JSON.parse(JSON.stringify(this.createTaskDatas));
        val[idx].provinceName = datas.province;
        val[idx].cityName = datas.city;
        val[idx].areaName = datas.district;
        this.createTaskDatas = val;
      });
    },
    // 收货地址（自动识别地址
    geocode(getAddress, getcity) {
      if (!getAddress) {
        return false;
      }
      let param = {
        address: getAddress || "",
        city: getcity || "",
      };
      this.$API.geocode(param).then((res) => {
        let result = res.data.result.geocodes || [];
        if (result.length == 0) {
          return false;
        }
        let datas = result[0] || "";
        let sj = JSON.parse(JSON.stringify(this.shouJiForm));
        sj.provinceName = datas.province;
        sj.cityName = datas.city;
        sj.areaName = datas.district;
        this.shouJiForm = sj;
      });
    },
    // 发货地址（自动识别
    geocodeFH(getAddress, idx) {
      if (!getAddress) {
        return false;
      }
      let param = {
        address: getAddress || "",
        city: "",
      };
      this.$API.geocode(param).then((res) => {
        let result = res.data.result.geocodes || [];
        if (result.length == 0) {
          return false;
        }
        let datas = result[0] || "";
        let val = JSON.parse(JSON.stringify(this.goodsInfoList));
        val[idx].addressReq.provinceName = datas.province;
        val[idx].addressReq.cityName = datas.city;
        val[idx].addressReq.areaName = datas.district;
        this.goodsInfoList = val;
      });
    },

    addTaskData() {
      this.createTaskDatas = [
        {
          address: "",
          areaName: "",
          carrierDeptId: "",
          carrierDeptName: "",
          carrierId: "",
          carrierName: "",
          cityName: "",
          company: "",
          contacts: "",
          externalCarrierId: "",
          externalCarrierName: "",
          phone: "",
          provinceName: "",
          remarks: "",
          storageId: "",
          storageName: "",
          tel: "",
          transportMethod: "qi_yun_pai_che:transport_method",
          transportPlan: "zhi_song:transport_plan",
          cityNameList: [],
          areaNameList: [],
          wbDepList: [],
          transportType: "ti_huo:transport_type", //运输类型   ti_huo:transport_type=提货 nei_bu_cang_pei_song:transport_type=内部仓配送 wai_bu_cang_pei_song:transport_type=外部仓配送
          waybillIdReqs: [], //运单信息 (直送)
          WBcarrierDeptName: "",
          wbcarrierDeptId: "",
          PSstorageId: "",
          PSstorageName: "",
          CarrierDeptListListGH: [],
        },
      ];
    },
    wtl_delTask(idx) {
      let that = this;
      let ids = this.createTaskDatas[idx].taskIds || [];
      this.$API.wtl_delTask({ taskIds: ids }).then((res) => {
        this.$message.success(res.data.message || "操作成功").showClose = true;
        this.isShowDialog_gh = false;
        this.createTaskDatas.splice(idx, 1);
        setTimeout(() => {
          that.guiHuaBtns();
        }, 100);
      });
    },
    saveRenWu(idx) {
      let transportType = this.createTaskDatas[idx].transportType || ""; //提货
      let waybillIdReqs = [
        {
          addrId: this.shouJiForm.addrId || "",
          waybillSplitId: this.waybillSplitId,
        },
      ];

      let startAddrReq = {
        carrierDeptId: this.createTaskDatas[idx].wbcarrierDeptId,
        carrierDeptName: this.createTaskDatas[idx].WBcarrierDeptName,
        carrierId: this.createTaskDatas[idx].externalCarrierId,
        carrierName: this.createTaskDatas[idx].externalCarrierName,
        storageId: this.createTaskDatas[idx].PSstorageId,
        storageName: this.createTaskDatas[idx].PSstorageName,
      }; //提货地址(仓配送时有值)
      delete this.createTaskDatas[idx].PSstorageId;
      delete this.createTaskDatas[idx].PSstorageName;
      delete this.createTaskDatas[idx].WBcarrierDeptName;
      delete this.createTaskDatas[idx].wbcarrierDeptId;
      delete this.createTaskDatas[idx].cityNameList;
      delete this.createTaskDatas[idx].areaNameList;
      delete this.createTaskDatas[idx].wbDepList;
      console.log(this.createTaskDatas[idx], "createTaskDatas");
      let param = {
        endAddrReq: this.createTaskDatas[idx], //目的地址
        startAddrReq: startAddrReq, //提货地址(仓配送时有值)
        waybillIdReqs: waybillIdReqs, //运单信息
        transportType: transportType, //运输类型
      };

      // return false;
      this.$API.wtl_createTask(param).then((res) => {
        this.$message.success(
          res.data.message || "生成任务成功"
        ).showClose = true;

        // 如果是入仓,生成多一个入仓任务
        console.log(
          this.createTaskDatas[idx].transportPlan,
          "this.createTaskDatas[idx].transportPlan"
        );
        if (
          this.createTaskDatas[idx].transportPlan == "ru_cang:transport_plan"
        ) {
          this.guiHuaBtns("ruCang");
        } else {
          this.guiHuaBtns();
        }
      });
    },

    // 规划 按钮
    guiHuaBtns(type) {
      this.getObjectUserDownListGH("storage");
      this.getchangeCarrierGH();
      this.$API
        .getWaybillTaskList({ waybillSpitId: this.waybillSplitId })
        .then((res) => {
          console.log(res, "aares");
          let datas = res.data.result || [];
          if (datas.length == 0) {
            this.createTaskDatas = [];
            return false;
          }
          datas.forEach((item) => {
            item.provinceName = item.unloadProvinceName;
            item.cityName = item.unloadCityName;
            item.areaName = item.unloadAreaName;
            item.address = item.unloadAddress;
          });

          if (type == "ruCang") {
            datas.push({
              address: "",
              areaName: "",
              carrierDeptId: "",
              carrierDeptName: "",
              carrierId: "",
              carrierName: "",
              cityName: "",
              company: "",
              contacts: "",
              externalCarrierId: "",
              externalCarrierName: "",
              phone: "",
              provinceName: "",
              remarks: "",
              storageId: "",
              storageName: "",
              tel: "",
              transportMethod: "qi_yun_pai_che:transport_method",
              transportPlan: "ru_cang:transport_plan",
              cityNameList: [],
              areaNameList: [],
              wbDepList: [],
              transportType: "nei_bu_cang_pei_song:transport_type", //运输类型   ti_huo:transport_type=提货 nei_bu_cang_pei_song:transport_type=内部仓配送 wai_bu_cang_pei_song:transport_type=外部仓配送
              waybillIdReqs: [], //运单信息 (直送)
              WBcarrierDeptName: "",
              wbcarrierDeptId: "",
              PSstorageId: "",
              PSstorageName: "",
              CarrierDeptListListGH: [],
            });
          }

          this.createTaskDatas = datas;
        });
      this.isShowDialog_gh = true;
    },
    // 选择入仓仓库
    changeStorageList(e) {
      console.log(e);
      this.transportPlanInfoReq.storageName = "";
      if (e) {
        this.storageList.forEach((item) => {
          if (item.documentId == e) {
            this.transportPlanInfoReq.storageName = item.name;
          }
        });
      }
    },
    // 选择入仓仓库
    changeStorageListGH(e, idx) {
      this.createTaskDatas[idx].storageName = "";
      if (e) {
        this.storageListGH.forEach((item) => {
          if (item.documentId == e) {
            this.createTaskDatas[idx].storageName = item.name;
          }
        });
      }
    },
    // 配送仓库
    changeStorageListGH_nb(e, idx) {
      this.createTaskDatas[idx].PSstorageName = "";
      if (e) {
        this.storageListGH.forEach((item) => {
          if (item.documentId == e) {
            this.createTaskDatas[idx].PSstorageName = item.name;
          }
        });
      }
    },
    changeTH(e) {
      console.log(e);
      this.transportPlanInfoReq.outgoingReceiveMethod = "";
      if (e) {
        this.OUTTakeMethodList.forEach((element) => {
          if (element.confDictId == e) {
            this.transportPlanInfoReq.outgoingReceiveMethod = element.val;
          }
        });
      }
    },
    changeSH(e) {
      this.transportPlanInfoReq.outgoingSendMethod = "";
      if (e) {
        this.OUTsendMethodList.forEach((element) => {
          if (element.confDictId == e) {
            this.transportPlanInfoReq.outgoingSendMethod = element.val;
          }
        });
      }
    },
    // 承运商列表
    getchangeCarrier(e) {
      this.$COMAPI.changeCarrier(e).then((res) => {
        this.changeCarrierList = res || [];
      });
    },
    // 承运商列表(规划)
    getchangeCarrierGH(e) {
      this.$COMAPI.changeCarrier(e).then((res) => {
        this.changeCarrierListGH = res || [];
      });
    },
    // 选择承运商(外发)
    changecarrierName2(e) {
      this.transportPlanInfoReq.carrierDeptId = "";
      this.transportPlanInfoReq.carrierId = "";
      if (e) {
        this.changeCarrierList.forEach((item) => {
          if (item.carrierName == e) {
            this.transportPlanInfoReq.carrierId = item.carrierId;
            this.getCarrierDeptList(item.carrierId);
          }
        });
      }
    },
    // 选择承运商(规划)
    changecarrierName2GH(e, idx) {
      console.log("aaaa", e, idx);
      this.createTaskDatas[idx].carrierDeptId = "";
      this.createTaskDatas[idx].carrierId = "";
      if (e) {
        this.changeCarrierListGH.forEach((item) => {
          if (item.carrierName == e) {
            this.createTaskDatas[idx].carrierId = item.carrierId;
            this.getCarrierDeptListGH(item.carrierId, idx);
          }
        });
      }
    },
    // 选择承运商(规划,外部仓配)
    changecarrierName2GH_wb(e, idx) {
      this.createTaskDatas[idx].externalCarrierId = "";
      if (e) {
        this.changeCarrierListGH.forEach((item) => {
          if (item.carrierName == e) {
            this.createTaskDatas[idx].externalCarrierId = item.carrierId;
            this.getCarrierDeptListGH_wb(item.carrierId, idx);
          }
        });
      }
    },
    // 选择承运商网点(规划,外部仓配)
    changeWBWD(e, idx) {
      this.createTaskDatas[idx].WBcarrierDeptName = "";
      if (e) {
        this.createTaskDatas[idx].wbDepList.forEach((item) => {
          if (item.carrierDeptId == e) {
            this.createTaskDatas[idx].WBcarrierDeptName = item.deptName;
          }
        });
      }
    },
    // 登录账号的承运商默认网点
    changeCarrierDeptName(e) {
      this.transportPlanInfoReq.carrierDeptName = "";
      console.log(e, "aaaaaede");
      if (e) {
        this.CarrierDeptListList.forEach((item) => {
          if (item.carrierDeptId == e) {
            this.transportPlanInfoReq.carrierDeptName = item.deptName;
          }
        });
      }
    },

    // 获取承运商网点
    getCarrierDeptList(id) {
      this.$COMAPI.CarrierDeptList(id).then((res) => {
        this.CarrierDeptListList = res || [];
      });
    },
    // 获取承运商网点(规划)
    getCarrierDeptListGH(id, idx) {
      this.$COMAPI.CarrierDeptList(id).then((res) => {
        this.createTaskDatas[idx].CarrierDeptListListGH = res || [];
      });
    },
    // 获取承运商网点(外部仓配)
    getCarrierDeptListGH_wb(id, idx) {
      this.$COMAPI.CarrierDeptList(id).then((res) => {
        this.createTaskDatas[idx].wbDepList = res || [];
      });
    },

    // 获取运单财务信息
    getWaybillFinance() {
      this.$API
        .wtl_getWaybillFinance({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          let datas = res.data.result || "";
          this.CaiWuData = JSON.parse(JSON.stringify(datas.financeInInfoVo));
          this.types = this.CaiWuData.formulaBillingWeightKey;
          delete this.CaiWuData.formulaBillingWeightKey;
          delete this.CaiWuData.formulaBillingWeightVal;
          this.isPosting = datas.financeInInfoVo.isPosting == 1 ? true : false;
          this.CaiWuData.itemServiceReqs = datas.financeInInfoVo.itemServiceVos;
          this.CaiWuData.settlementMethodConfDictId =
            datas.financeInInfoVo.settlementMethodConfDictId;
          this.CaiWuData.delItemServiceReqs = [];
          this.CaiWuData.itemServiceReqs.forEach((item) => {
            item.operationType = "UPDATE";
          });
          this.changeSettlementMethod(
            this.CaiWuData.settlementMethodConfDictId
          );
          // 应付
          this.financeOutInfoReqs = datas.financeOutinfoVos;
          this.financeOutInfoReqs.forEach((item) => {
            item.operationType = "UPDATE";
          });
        });
    },

    //  获取运单详情
    getPackageDetails() {
      this.$API
        .wtl_getWaybillDetail({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          let datas = res.data.result;
          this.transportPlanInfoReq = datas.transportPlanInfoVo;
          if (
            this.transportPlanInfoReq &&
            this.transportPlanInfoReq.transportPlan
          ) {
            this.isTiHuoGuiHUa = true;
            if (this.transportPlanInfoReq.carrierId) {
              this.getCarrierDeptList(this.transportPlanInfoReq.carrierId);
            }
          } else {
            this.isTiHuoGuiHUa = false;
          }
          // 基本信息
          this.baseInForm = datas.baseInfoVo;
          this.baseInForm.isReturnGoods = this.baseInForm.isReturnGoods + "";
          this.baseInForm.isWaitNoticeSend =
            this.baseInForm.isWaitNoticeSend + "";
          this.baseInForm.carrierName = this.baseInForm.outboundCarrierName;
          this.baseInForm.customerNumber = this.baseInForm.customereOrderNumber;
          this.baseInForm.outboundCarrierId =
            this.baseInForm.outboundCarrierId + "";

          if (this.baseInForm.rnRequireConfDictId) {
            this.isNeedHd = "1";
          } else {
            this.isNeedHd = "0";
          }

          // 收件人信息
          this.shouJiForm = datas.receiveAddressVo;
          this.shouJiForm.operationType = "UPDATE";
          this.getCityName(this.shouJiForm.provinceName); //获取市下拉列表
          this.getAreaName(this.shouJiForm.cityName); //获取区下拉列表

          // 货物信息
          let arrs = [];
          datas.takeAddressVos.forEach((item, index) => {
            //处理提货地址
            let obj = item.addressVo;
            obj.cityNameList = [];
            obj.areaNameList = [];
            this.getCityNameFH(obj.provinceName, index);
            this.getAreaNameFH(obj.cityName, index);
            obj.operationType = "UPDATE";
            obj.addressId = obj.addrId;
            delete obj.addrId;
            // 处理货物信息
            let array = item.itemVos;
            array.forEach((item2) => {
              // 品类和包装
              item2.CategoryList = JSON.parse(
                JSON.stringify(this.CategoryList || [])
              );
              item2.packageNameList = JSON.parse(
                JSON.stringify(this.packageNameList || [])
              );
              item2.operationType = "UPDATE";
              item2.addressId = item2.addrId;
              item2.goodsId = item2.itemId;
              delete item2.addrId;
              delete item2.itemId;
            });
            let items = {
              addressReq: obj,
              itemReqs: array,
              DelitemReqs: [],
            };
            arrs.push(items);
          });
          this.goodsInfoList = arrs;

          //图片信息
          let fileVoList = datas.fileVoList || [];
          let fileArrs = [];
          fileVoList.forEach((item) => {
            let objs = {
              name: item.fileName,
              url: item.url,
              operationType: "UPDATE",
            };
            fileArrs.push(objs);
          });
          this.fileVoListAll = fileArrs; //初始的图片
          this.fileNameLists = fileArrs; //显示的,
        });
    },
    // 选择承运商
    changeCarrier(e) {
      if (e) {
        this.CarrierLists.forEach((item) => {
          if (item.carrierName == e) {
            this.baseInForm.outboundCarrierId = item.carrierId;
          }
        });
      } else {
        this.getCarrierList();
      }
    },
    // 获取承运商列表
    getCarrierList(carrierName) {
      this.$API
        .CarrierList({
          pageStart: 1,
          pageTotal: 200,
          carrierName: carrierName || "",
        })
        .then((res) => {
          this.CarrierLists = res.data.result.data || [];
        });
    },
    // 选择省查市(规划)
    changeProvinceGh(e, idx) {
      console.log("aaaeee", e);
      this.createTaskDatas[idx].cityName = "";
      this.createTaskDatas[idx].cityNameList = [];
      this.createTaskDatas[idx].areaName = "";
      this.createTaskDatas[idx].areaNameList = [];
      if (e) {
        this.getCityNameGH(e, idx);
      }
    },
    // 选择市查区(规划)
    changeCityGH(e, idx) {
      this.createTaskDatas[idx].areaName = "";
      this.createTaskDatas[idx].cityNameList = [];
      if (e) {
        this.getAreaNameGH(e, idx);
      }
    },
    // 获取市 (规划)
    getCityNameGH(e, idx) {
      console.log("获取市", e);
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.createTaskDatas[idx].cityNameList = res.data.result.data || [];
        });
    },
    // 获取区 (规划)
    getAreaNameGH(e, idx) {
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.createTaskDatas[idx].areaNameList = res.data.result.data || [];
        });
    },

    // 选择结算方式
    changeSettlementMethod(e) {
      let val = "";
      this.settlementMethodList.forEach((item) => {
        if (item.confDictId == e) {
          val = item.key;
        }
      });

      this.amountIsAble = true;
      if (val == "ji_fu_xian_jie") {
        //寄付现结
        this.CaiWuData.senderAmount = this.CaiWuData.billingAmount || 0; //寄付
        this.CaiWuData.receivedAmount = 0; //到付
        this.CaiWuData.monthlyAmount = 0; //月结
        this.CaiWuData.rnorderAmount = 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      } else if (val == "dao_fu") {
        //到付
        this.CaiWuData.senderAmount = 0; //寄付
        this.CaiWuData.receivedAmount = this.CaiWuData.billingAmount || 0; //到付
        this.CaiWuData.monthlyAmount = 0; //月结
        this.CaiWuData.rnorderAmount = 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      } else if (val == "ji_fu_yue_jie") {
        //寄付月结
        this.CaiWuData.senderAmount = 0; //寄付
        this.CaiWuData.receivedAmount = 0; //到付
        this.CaiWuData.monthlyAmount = this.CaiWuData.billingAmount || 0; //月结
        this.CaiWuData.rnorderAmount = 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      } else if (val == "ji_fu_hui_dan_jie") {
        //寄付回单结
        this.CaiWuData.senderAmount = 0; //寄付
        this.CaiWuData.receivedAmount = 0; //到付
        this.CaiWuData.monthlyAmount = 0; //月结
        this.CaiWuData.rnorderAmount = this.CaiWuData.billingAmount || 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      } else if (val == "duo_bi_fu") {
        //多笔付
        this.amountIsAble = false;

        // this.CaiWuData.senderAmount = 0; //寄付
        // this.CaiWuData.receivedAmount = 0; //到付
        // this.CaiWuData.monthlyAmount = 0; //月结
        // this.CaiWuData.rnorderAmount = 0; //回单结
        // this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      } else if (val == "dai_shou_huo_kuan_kou") {
        //代收货款扣
        this.CaiWuData.senderAmount = 0; //寄付
        this.CaiWuData.receivedAmount = 0; //到付
        this.CaiWuData.monthlyAmount = 0; //月结
        this.CaiWuData.rnorderAmount = 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = this.CaiWuData.billingAmount || 0; //货款扣运费
      } else if (val == "mian_fei") {
        //免费
        this.CaiWuData.senderAmount = 0; //寄付
        this.CaiWuData.receivedAmount = 0; //到付
        this.CaiWuData.monthlyAmount = 0; //月结
        this.CaiWuData.rnorderAmount = 0; //回单结
        this.CaiWuData.goodsDeductedAmoun = 0; //货款扣运费
      }
    },
    // 默认查省级
    getParentName(e) {
      let p = {
        pageStart: 1,
        pageTotal: 100,
        parentName: e,
      };
      this.$API.wtl_getDistrictList(p).then((res) => {
        this.SuperiorRegionList = res.data.result.data || [];
      });
    },
    // 获取市 (收货地址)
    getCityName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.cityNameList = res.data.result.data || [];
        });
    },
    // 获取区 (收货地址)
    getAreaName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.areaNameList = res.data.result.data || [];
        });
    },
    // 获取市 (发货地址)
    getCityNameFH(e, idx) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          let arrs = JSON.parse(JSON.stringify(this.goodsInfoList));
          arrs[idx].cityNameList = res.data.result.data || [];
          this.goodsInfoList = arrs;
        });
    },
    // 获取区 (发货地址)
    getAreaNameFH(e, idx) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          let arrs = JSON.parse(JSON.stringify(this.goodsInfoList));
          arrs[idx].areaNameList = res.data.result.data || [];
          this.goodsInfoList = arrs;
        });
    },
    // 选择省(收货地址)
    changeProvince(e) {
      this.shouJiForm.cityName = "";
      this.shouJiForm.areaName = "";
      this.cityNameList = [];
      this.areaNameList = [];
      if (e) {
        this.getCityName(e);
      }
    },
    // 选择市(收货)
    changeCity(e) {
      this.shouJiForm.areaName = "";
      this.areaNameList = [];
      if (e) {
        this.getAreaName(e);
      }
    },

    // 选择省查市(发货)
    changeProvinceFH(e, idx) {
      this.goodsInfoList[idx].addressReq.cityName = "";
      this.goodsInfoList[idx].addressReq.cityNameList = [];
      this.goodsInfoList[idx].addressReq.areaName = "";
      this.goodsInfoList[idx].addressReq.areaNameList = [];
      if (e) {
        this.getCityNameFH(e, idx);
      }
    },
    // 选择市查区(发货)
    changeCityFH(e, idx) {
      this.goodsInfoList[idx].addressReq.areaName = "";
      this.goodsInfoList[idx].addressReq.cityNameList = [];
      if (e) {
        this.getAreaNameFH(e, idx);
      }
    },
    // 计算货物信息表格的运费
    getGoodsTable(a, b) {
      let num1 = this.goodsInfoList[a].itemReqs[b].billingWeight || 0; //计费取值
      let num2 = this.goodsInfoList[a].itemReqs[b].unitPrice || 0; //单价
      this.goodsInfoList[a].itemReqs[b].freight = this.$TOOLS.mul(num1, num2);
      this.getBasicFreight();
    },
    // 税金
    getTaxes() {
      let num1 = this.CaiWuData.totalFreight || 0; //运费合计
      let num2 = this.CaiWuData.invoiceTaxPoint || 0; //税点
      let num3 = this.$TOOLS.divide(num2, 100);
      this.CaiWuData.taxes = this.$TOOLS.mul(num1, num3).toFixed(2);
    },
    // 计算:基本运费
    getBasicFreight() {
      let array = [];
      this.goodsInfoList.forEach((item) => {
        item.itemReqs.forEach((item2) => {
          array.push(item2.freight);
        });
      });
      this.CaiWuData.basicFreight = this.$TOOLS.getAddMathNumber(array);
    },
    // 计算:其他费用
    getOtherExpenses(arr) {
      let array = [];
      if (arr) {
        array = arr;
      } else {
        // 动态计算其他费用
        this.CaiWuData.itemServiceReqs.forEach((item) => {
          array.push(item.amount);
        });
      }

      this.CaiWuData.allOtherFee = this.$TOOLS.getAddMathNumber(array);
    },
    // 计算:开单金额
    getBillingAmount() {
      let num1 = this.CaiWuData.totalFreight || 0; //运费合计
      let num2 = this.CaiWuData.taxes || 0; //税金
      let array = [num1, num2];
      this.CaiWuData.billingAmount = this.$TOOLS.getAddMathNumber(array);
    },
    // 计算:运费合计
    getTotalFreight() {
      let num1 = this.CaiWuData.basicFreight || 0; //基本运费
      let num2 = this.CaiWuData.takeFee || 0; //提货费
      let num3 = this.CaiWuData.sendFee || 0; //送货费
      let num4 = this.CaiWuData.unLoadFee || 0; //装卸费
      let num5 = this.CaiWuData.insuranceFee || 0; //保险费
      let num6 = this.CaiWuData.allOtherFee || 0; //其他费用
      let array = [num1, num2, num3, num4, num5, num6];

      this.CaiWuData.totalFreight = this.$TOOLS.getAddMathNumber(array);
    },

    // 费型类型下拉列表
    itemCategorChoose(categoryName) {
      this.$API
        .itemCategorChoose({ categoryName: categoryName })
        .then((res) => {
          this.categoryNameList = res.data.result || [];
        });
    },
    //选择费项类型(应收)
    changeItemCategoryId(e) {
      if (e) {
        this.wtl_itemServiceListAll(e, "shou:direction_status");
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogForm.itemCategoryName = item.categoryName;
          }
        });
      } else {
        this.dialogForm.itemServiceId = "";
        this.dialogForm.amount = "";
        this.dialogForm.itemServiceName = "";
      }
    },

    //选择费项
    changeItemServiceId(e) {
      if (e) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == e) {
            this.dialogForm.amount = item.unitPrice;
            this.dialogForm.itemServiceName = item.title;
          }
        });
      } else {
        this.dialogForm.amount = "";
        this.dialogForm.itemServiceName = "";
      }
    },
    //选择费项类型(应付)
    changeItemCategoryIdYF(e) {
      this.dialogForm2.itemServiceId = "";
      this.dialogForm2.amount = "";
      this.dialogForm2.itemServiceName = "";
      if (e) {
        this.wtl_itemServiceListAll(e, "fu:direction_status");
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogForm2.itemCategoryName = item.categoryName;
          }
        });
      }
    },
    // 选择结算对象类型
    changeObjestStatus(e) {
      this.dialogForm2.objectName = "";
      this.dialogForm2.objectNumber = "";
      this.dialogForm2.objectStatusConfDictId = "";
      if (e) {
        this.objectStatusList.forEach((item) => {
          if (item.key == e) {
            this.dialogForm2.objectStatusConfDictId = item.confDictId;
            this.dialogForm2.objectStatus = item.val;
          }
        });

        this.getObjectUserDownListYf();
      }
    },
    //选择费项(应付弹窗)
    changeItemServiceId2(e) {
      this.dialogForm2.amount = "";
      this.dialogForm2.itemServiceName = "";
      if (e) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == e) {
            this.dialogForm2.amount = item.unitPrice;
            this.dialogForm2.itemServiceName = item.title;
          }
        });
      }
    },
    //选择付款方式(应付弹窗)
    changePayMent(e) {
      if (e) {
        this.settlementMethodList.forEach((item) => {
          if (item.confDictId == e) {
            this.dialogForm2.paymentMethod = item.val;
          }
        });
      } else {
        this.dialogForm2.amount = "";
        this.dialogForm2.itemServiceName = "";
      }
    },
    // 根据类别和费项类型获取费项
    wtl_itemServiceListAll(e, directionStatus) {
      this.$API
        .wtl_getCategoryServiceList({
          categoryId: e || "",
          directionStatus: directionStatus || "",
        })
        .then((res) => {
          this.CategoryServiceList = res.data.result || [];
        });
    },
    // 获取品类
    getCategoryList(categoryName) {
      this.$API
        .wtl_getCategoryList({
          categoryName: categoryName,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CategoryList = res.data.result.data || [];
          this.goodsInfoList[0].itemReqs[0].CategoryList = this.CategoryList;
        });
    },
    // 收-发货人列表
    getCustomerAddrList() {
      this.$API
        .wtl_getCustomerAddrList({
          customerId: this.queryData.customerId,
          addressType: this.queryData.addressType,
        })
        .then((res) => {
          this.tableData = res.data.result.data || [];
        });
    },
    // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 选择收件人地址
    changeRecAddress(type, idx) {
      // this.isShowDialog3 = true;
      if (type == 1) {
        this.dialogTitle3 = "选择收货地址";
        this.queryData.addressType = "shou_jian:address_type";
        // this.queryData.customerId = this.contactsId || "";
      } else {
        this.dialogTitle3 = "选择发货地址";
        this.queryData.addressType = "ji_jian:address_type";
        this.addressIdx = idx || 0;
      }

      this.queryData.customerId = this.baseInForm.customerId + "" || "";

      if (this.baseInForm.customerId) {
        this.isShowDialog3 = true;
        this.getCustomerListAddress();
        this.getCustomerAddrList();
      } else {
        if (this.baseInForm.customerName) {
          this.$message.warning("当前客户没有客户档案").showClose = true;
        } else {
          this.$message.warning("请先选择客户").showClose = true;
        }

        return false;
      }
    },
    // 选择地址
    changeAddress(row) {
      console.log("row", row);
      if (this.queryData.addressType == "ji_jian:address_type") {
        //寄件
        // this.goodsInfoList[this.addressIdx].z;
        this.goodsInfoList[this.addressIdx].addressReq.company =
          row.deptName || "";
        this.goodsInfoList[this.addressIdx].addressReq.contacts =
          row.personnelName || "";
        this.goodsInfoList[this.addressIdx].addressReq.phone = row.tel || "";
        this.goodsInfoList[this.addressIdx].addressReq.provinceName =
          row.provinceName || "";
        this.goodsInfoList[this.addressIdx].addressReq.cityName =
          row.cityName || "";
        this.goodsInfoList[this.addressIdx].addressReq.areaName =
          row.areaName || "";
        this.goodsInfoList[this.addressIdx].addressReq.address =
          row.address || "";
        this.isShowDialog3 = false;
        // this.changeProvinceFH(row.provinceName, this.addressIdx);
        // this.changeCityFH(row.cityName, this.addressIdx);
        this.getCityNameFH(row.provinceName, this.addressIdx);
        this.getAreaNameFH(row.cityName, this.addressIdx);
      } else {
        //收件
        this.shouJiForm.company = row.deptName || "";
        this.shouJiForm.contacts = row.personnelName || "";
        this.shouJiForm.phone = row.tel || "";
        this.shouJiForm.provinceName = row.provinceName || "";
        this.shouJiForm.cityName = row.cityName || "";
        this.shouJiForm.areaName = row.areaName || "";
        this.shouJiForm.address = row.address || "";
        this.isShowDialog3 = false;

        this.getCityName(row.provinceName);
        this.getAreaName(row.cityName);
      }
    },

    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(dictType) {
      this.$API
        .wtl_getConfDictValDownList({ dictType: dictType })
        .then((res) => {
          let arrs = res.data.result || [];
          if (dictType == "package_name") {
            // 包装
            this.packageNameList = arrs;
            this.goodsInfoList[0].itemReqs[0].packageNameList = arrs;
          }
          if (dictType == "waybill_type") {
            // 货物类型
            this.waybillTypeList = arrs;
          }
          if (dictType == "rn_order_require") {
            // 回单类型
            this.rnrderRequireList = arrs;
          }
          if (dictType == "send_method") {
            // 获取送货方式列表
            this.sendMethodList = arrs;
          }
          if (dictType == "receive_method") {
            // 获取收货方式列表
            this.ReceivingMethodList = arrs;
          }
          if (dictType == "transport_method") {
            // 获取运输方式列表
            this.transportModeList = arrs;
          }
          if (dictType == "object_status") {
            // 获取结算对象类型
            this.objectStatusList = arrs;
          }
          if (dictType == "settlement_method") {
            // 获取付款方式
            this.settlementMethodList = arrs;
          }
          if (dictType == "out_going_send_method") {
            // 外发送货方式
            this.OUTsendMethodList = arrs;
          }
          if (dictType == "out_going_take_method") {
            // 外发提货
            this.OUTTakeMethodList = arrs;
          }
          if (dictType == "out_going_billing_method") {
            // 计费方式
            this.out_going_billing_method_list = arrs;
          }
        });
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$API
        .wtl_getObjectUserDownList({
          key: key,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          if (key == "employee") {
            this.EmployeeList = arrs;
          }
          if (key == "dept") {
            this.depList = arrs;
          }
          if (key == "storage") {
            this.storageList = arrs;
          }
        });
    },
    // 获取入仓仓库
    getObjectUserDownListGH(key) {
      this.$API
        .wtl_getObjectUserDownList({
          key: key,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          if (key == "employee") {
            this.EmployeeList = arrs;
          }
          if (key == "dept") {
            this.depList = arrs;
          }
          if (key == "storage") {
            this.storageListGH = arrs;
          }
        });
    },
    // 获取组织架构列表
    getDeptList() {
      this.$API
        .wtl_getDeptList({
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.depList = res.data.result.data || [];
        });
    },

    // 获取客户列表
    getCustomerList(name) {
      // this.$API
      //   .wtl_getObjectUserDownList({
      //     key: "customer",
      //     name: name || "",
      //     pageStart: 1,
      //     pageTotal: 200,
      //   })
      //   .then((res) => {
      //     this.CustomerLists = res.data.result.data || [];
      //   });
      this.$API
        .CustomerList({
          customerName: name || "",
          pageStart: 1,
          pageTotal: 200,
          approveStatus: "tong_guo:approve_status",
        })
        .then((res) => {
          this.CustomerLists = res.data.result.data || [];
        });
    },
    // (应付弹窗)根据对象类型获取对象的下拉列表
    getObjectUserDownListYf(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: this.dialogForm2.objectStatusType || "",
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerListsYF = res.data.result.data || [];
        });
    },
    changeobjectName(e) {
      if (!e) {
        this.getObjectUserDownListYf();
      } else {
        this.CustomerListsYF.forEach((item) => {
          if (item.name === e) {
            this.dialogForm2.objectNumber = item.number;
            // this.dialogForm2.objectStatusConfDictId = item.documentId;
          }
        });
      }
    },
    // 获取客户档案列表()
    getCustomerListAddress(name) {
      this.$API
        .wtl_getCustomerList({
          customerName: name || "",
          approveStatus: "tong_guo:approve_status", //审核通过
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.addressNaemList = res.data.result.data || [];
        });
    },
    changecustomerId(e) {
      if (!e) {
        this.getCustomerListAddress();
      } else {
        this.getCustomerAddrList();
      }
    },
    //客户名称
    // 获取焦点的时候判断一下有没有数据,防止自定义输入时查出来空数组
    focusCustomer() {
      if (this.CustomerLists.length > 0) {
        return false;
      }
      // this.$API
      //   .wtl_getObjectUserDownList({
      //     key: "customer",
      //     name: "",
      //     pageStart: 1,
      //     pageTotal: 200,
      //   })
      //   .then((res) => {
      //     let arrs = res.data.result.data || [];

      //     this.CustomerLists = [...this.CustomerLists, ...arrs];
      //   });
      this.$API
        .CustomerList({
          customerName: name || "",
          pageStart: 1,
          pageTotal: 200,
          approveStatus: "tong_guo:approve_status",
        })
        .then((res) => {
          this.CustomerLists = res.data.result.data || [];
        });
    },
    // 选择回单要求
    changernRequireName(e) {
      // baseInForm.rnRequireConfDictId
      this.rnrderRequireList.forEach((item) => {
        if (e == item.confDictId) {
          this.baseInForm.rnRequireName = item.key;
        }
      });
    },
    // 选择或者清除客户时触发
    changeCustomer(e) {
      if (!e) {
        this.getCustomerList();
        this.baseInForm.customerId = "";
      } else {
        let isZDY = true;
        this.CustomerLists.forEach((item) => {
          if (item.customerName == e) {
            this.baseInForm.customerId = item.customerId;
            // 收货人
            // this.shouJiForm.contacts = item.name;
            this.contactsId = item.customerId;
            isZDY = false;
            this.isZDYCustomer = false;

            this.CaiWuData.isInvoice = item.isInvoicing + "";

            this.settlementMethodList.forEach((itemA) => {
              if (itemA.val == item.settlementMethod) {
                this.CaiWuData.settlementMethodConfDictId = itemA.confDictId;
              }
            });
            if (item.isInvoicing == 1) {
              this.CaiWuData.invoiceTaxPoint = item.taxPoint || "";
            } else {
              this.CaiWuData.invoiceTaxPoint = "";
            }
          }
        });
        if (isZDY) {
          this.isZDYCustomer = true;
          this.baseInForm.customerName = e;
          this.shouJiForm.contacts = e;
          this.baseInForm.customerId = "";
        }
      }
    },
    // 选择收货人
    changeCustomer2(e) {
      if (!e) {
        this.contactsId = "";
        this.getCustomerList();
      } else {
        let isZDY = true;
        this.CustomerLists.forEach((item) => {
          if (item.name == e) {
            // 收货人id
            this.contactsId = item.documentId;
            isZDY = false;
          }
        });
        if (isZDY) {
          this.contactsId = "";
          this.isZDYCustomer = true;
          this.shouJiForm.contacts = e;
        }
      }
    },
    // 自动生成单号
    autoCreateNumber() {
      this.$API.wtl_createBillNumber().then((res) => {
        this.baseInForm.waybillNumber = res.data.result.number || "";
      });
    },

    // 提交
    submit() {
      // 处理数据
      if (!this.CaiWuData.settlementMethodConfDictId) {
        this.$message.error("结算方式不能为空");
        return false;
      }

      // 运单基本信息
      let baseInfoReq = JSON.parse(JSON.stringify(this.baseInForm));
      if (this.isZDYCustomer) {
        // 如果是自定义的客户名称,需要清掉客户id
        baseInfoReq.customerId = "";
      }
      delete baseInfoReq.carrierName;
      baseInfoReq.isReturnGoods = baseInfoReq.isReturnGoods || 0;
      baseInfoReq.isWaitNoticeSend = baseInfoReq.isWaitNoticeSend || 0;
      baseInfoReq.rnRequireCount = baseInfoReq.rnRequireCount || 0;
      baseInfoReq.takeTime = baseInfoReq.takeTime
        ? baseInfoReq.takeTime + " 00:00:00"
        : "";
      baseInfoReq.deliveryTime = baseInfoReq.deliveryTime
        ? baseInfoReq.deliveryTime + " 00:00:00"
        : "";

      // 运单财务应收信息
      let financeInInfoReq = JSON.parse(JSON.stringify(this.CaiWuData));
      // 金额这些如果没有要传0
      financeInInfoReq.agentAmount = financeInInfoReq.agentAmount || 0;
      financeInInfoReq.allOtherFee = financeInInfoReq.allOtherFee || 0;
      financeInInfoReq.basicFreight = financeInInfoReq.basicFreight || 0;
      financeInInfoReq.billingAmount = financeInInfoReq.billingAmount || 0;
      financeInInfoReq.goodsDeductedAmoun =
        financeInInfoReq.goodsDeductedAmoun || 0;
      financeInInfoReq.insuranceFee = financeInInfoReq.insuranceFee || 0;
      financeInInfoReq.invoiceTaxPoint = financeInInfoReq.invoiceTaxPoint || 0;
      financeInInfoReq.isInvoice = financeInInfoReq.isInvoice || 0;
      financeInInfoReq.monthlyAmount = financeInInfoReq.monthlyAmount || 0;
      financeInInfoReq.receivedAmount = financeInInfoReq.receivedAmount || 0;
      financeInInfoReq.rnorderAmount = financeInInfoReq.rnorderAmount || 0;
      financeInInfoReq.sendFee = financeInInfoReq.sendFee || 0;
      financeInInfoReq.senderAmount = financeInInfoReq.senderAmount || 0;
      financeInInfoReq.takeFee = financeInInfoReq.takeFee || 0;
      financeInInfoReq.taxes = financeInInfoReq.taxes || 0;
      financeInInfoReq.totalFreight = financeInInfoReq.totalFreight || 0;
      financeInInfoReq.unLoadFee = financeInInfoReq.unLoadFee || 0;

      financeInInfoReq.itemServiceReqs = [
        ...financeInInfoReq.itemServiceReqs,
        ...financeInInfoReq.delItemServiceReqs,
      ];
      delete financeInInfoReq.itemServiceVos;
      delete financeInInfoReq.delItemServiceReqs;
      // 运单财务应付信息
      let financeOutInfoReqs = JSON.parse(
        JSON.stringify(this.financeOutInfoReqs)
      );

      financeOutInfoReqs = [...financeOutInfoReqs, ...this.delItemServiceReqs2];
      financeOutInfoReqs.forEach((item) => {
        delete item.objectStatusType;
        delete item.paymentMethod;
        delete item.objectStatus;
        item.amount = item.amount || 0;
      });
      // 运单收货地址信息
      let receiveAddrReq = JSON.parse(JSON.stringify(this.shouJiForm));
      // 运单提货地址信息
      let takeAddrItemReqs =
        JSON.parse(JSON.stringify(this.goodsInfoList)) || [];
      //把删除的项加进来
      takeAddrItemReqs = [...takeAddrItemReqs, ...this.DelGOodsInfoList];
      takeAddrItemReqs.forEach((item) => {
        item.itemReqs = [...item.itemReqs, ...item.DelitemReqs];
      });

      takeAddrItemReqs.forEach((item, index) => {
        item.addressReq.serialNumber = index + 1;
        //
        item.itemReqs.forEach((item2, index2) => {
          item2.serialNumber = index2 + 1;
          delete item2.CategoryList;
          delete item2.packageNameList;
        });
        delete item.DelitemReqs;
        delete item.cityNameList;
        delete item.areaNameList;
        delete item.CarrierDeptListListGH;
      });
      let financeInfoReq = {
        financeInInfoReq,
        financeOutInfoReqs,
        waybillSplitId: this.waybillSplitId,
        sign: "",
      };

      this.fileNameLists.forEach((item) => {
        item.operationType =
          item.operationType && item.operationType == "UPDATE"
            ? "UPDATE"
            : "ADD";
      });

      let ArrayA = JSON.parse(JSON.stringify(this.fileVoListAll || [])); //[1,2,3]
      let ArrayB = JSON.parse(JSON.stringify(this.fileNameLists || [])); //[1,3,4]

      let ArrayIDB = [];
      ArrayIDB = ArrayB.map((items) => {
        return items.name;
      });
      console.log("现在的图片数组", ArrayIDB);

      let DELImgs = []; //找出删除的图片
      ArrayA.forEach((item) => {
        if (ArrayIDB.indexOf(item.name) === -1) {
          item.operationType = "DEL";
          DELImgs.push(item);
        }
      });

      let fileNameAlls = [...this.fileNameLists, ...DELImgs];

      let fids = [];
      fileNameAlls.forEach((item) => {
        let objs = {
          fileId: item.name,
          operationType: item.operationType,
        };
        fids.push(objs);
      });

      let param = {
        files: fids,
        baseInfoReq: baseInfoReq,
        // financeInInfoReq: financeInInfoReq,
        // financeOutInfoReqs: financeOutInfoReqs,
        financeInfoReq: financeInfoReq,
        receiveAddrReq: receiveAddrReq,
        takeAddrItemReqs: takeAddrItemReqs,
      };
      if (this.isPosting) {
        delete param.financeInfoReq;
      }

      this.$API.wtl_updateWaybill(param).then((res) => {
        this.$message.success(res.data.message || "修改成功");
        this.$TOOLS.closePage();
        this.$router.push({
          path: "/WaybillManage/ComprehensiveQuery",
          query: {
            isreload: "isreload",
          },
        });
      });
    },

    // 添加一行货物信息
    AddGoods(idx, idx2) {
      let items = {
        billingWeight: "",
        freight: "",
        goodsName: "",
        goodsNumber: "",
        grossWeight: "",
        itemCategoryCode: "",
        itemCategoryName: "",
        netWeight: "",
        packageCout: "",
        packageName: "",
        serialNumber: "",
        specs: "",
        unitPrice: "",
        volume: "",
        volumeWeight: "",
        CategoryList: JSON.parse(JSON.stringify(this.CategoryList || [])),
        packageNameList: JSON.parse(JSON.stringify(this.packageNameList || [])),
        operationType: "ADD",
      };
      // this.goodsInfoList[idx].itemReqs[idx2].packageNameList =this.packageNameList;
      this.goodsInfoList[idx].itemReqs.push(items);
      this.goodsInfoList[idx].DelitemReqs = [];
    },
    // 删除一行货物信息
    delGoods(idx1, idx2) {
      let delDatas = this.goodsInfoList[idx1].itemReqs[idx2];
      if (delDatas.operationType == "ADD") {
      } else {
        delDatas.operationType = "DEL";
        this.goodsInfoList[idx1].DelitemReqs.push(delDatas);
      }
      this.goodsInfoList[idx1].itemReqs.splice(idx2, 1);
    },
    // 添加一应收费项
    AddFeiXian() {
      this.isShowDialog = true;
      this.dialogTitle = "新建应收费项";
      this.dialogType = "add";
      this.itemCategorChoose(); //费型类型下拉列表
    },
    editFeiXian(row, deitIdx) {
      this.isShowDialog = true;
      this.dialogTitle = "编辑应收费项";
      this.dialogType = "edit";
      this.deitIdx = deitIdx;
      this.dialogForm = JSON.parse(JSON.stringify(row));

      this.itemCategorChoose(); //费型类型下拉列表
    },
    // 添加应付弹窗
    addYinFu() {
      this.isShowDialog2 = true;
      this.dialogTitle2 = "新建应付";
      this.dialogType2 = "add";

      this.itemCategorChoose(); //费型类型下拉列表
      this.getConfDictValDownList("object_status"); //结算对象类型
    },
    // 删除一行应收费项
    delFeiXian(idx2) {
      if (this.CaiWuData.itemServiceReqs[idx2].operationType !== "ADD") {
        this.CaiWuData.itemServiceReqs[idx2].operationType = "DEL";
        this.CaiWuData.delItemServiceReqs.push(
          this.CaiWuData.itemServiceReqs[idx2]
        );
      }

      this.CaiWuData.itemServiceReqs.splice(idx2, 1);
      this.getOtherExpenses();
    },
    // 删除一行应付费项
    delFeiXian2(idx2) {
      let data = JSON.parse(JSON.stringify(this.financeOutInfoReqs[idx2]));
      if (data.operationType !== "ADD") {
        data.operationType = "DEL";
        this.delItemServiceReqs2.push(data);
      }

      this.financeOutInfoReqs.splice(idx2, 1);
    },
    EditFeiXian(row, idx) {
      console.log("row", row);
      this.dialogTitle2 = "编辑应付";
      this.dialogType2 = "edit";
      this.editYfIdx = idx;
      let datas = JSON.parse(JSON.stringify(row));

      let inoutStatus = this.dialogForm2.inoutStatus;
      this.dialogForm2 = datas; //如果不转表格跟弹窗的数据会一起变
      this.dialogForm2.inoutStatus = inoutStatus;
      this.dialogForm2.objectStatusType = "";
      this.itemCategorChoose(); //费型类型下拉列表
      this.wtl_itemServiceListAll(
        this.dialogForm2.itemCategoryId,
        "fu:direction_status"
      ); //获取费项(应收)

      this.$API
        .wtl_getConfDictValDownList({ dictType: "object_status" })
        .then((res) => {
          let arrs = res.data.result || [];
          // 获取结算对象类型
          this.objectStatusList = arrs;
          this.objectStatusList.forEach((item) => {
            if (item.val == this.dialogForm2.objectStatus) {
              this.dialogForm2.objectStatusType = item.key;
              this.getObjectUserDownListYf(); //获取结算对象
            }
          });
          this.isShowDialog2 = true;
        });
    },
    // 添加提货地址
    addDiZhi() {
      let obj = {
        addressReq: {
          address: "",
          addressType: "",
          areaName: "",
          cityName: "",
          company: "",
          contacts: "",
          phone: "",
          provinceName: "",
          serialNumber: "",
          tel: "",
          operationType: "ADD",
        },
        itemReqs: [
          {
            billingWeight: "",
            freight: "",
            goodsName: "",
            goodsNumber: "",
            grossWeight: "",
            itemCategoryCode: "",
            itemCategoryName: "",
            netWeight: "",
            packageCout: "",
            packageName: "",
            serialNumber: "",
            specs: "",
            unitPrice: "",
            volume: "",
            volumeWeight: "",
            CategoryList: JSON.parse(JSON.stringify(this.CategoryList || [])),
            packageNameList: JSON.parse(
              JSON.stringify(this.packageNameList || [])
            ),
            operationType: "ADD",
          },
        ],
        DelitemReqs: [],
      };
      this.goodsInfoList.push(obj);
    },
    // 删除提货地址
    delDiZhi(idx) {
      let delDatas = this.goodsInfoList[idx];
      if (delDatas.addressReq.operationType == "ADD") {
      } else {
        delDatas.addressReq.operationType = "DEL";
        this.DelGOodsInfoList.push(delDatas);
      }

      this.goodsInfoList.splice(idx, 1);
      this.getBasicFreight();
    },
    // 选择品名
    changeGoodsName(val, idx) {},

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.dialogForm = {
        amount: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        remarks: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      // 添加费项
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let datas = JSON.parse(JSON.stringify(this.dialogForm));
          let items = {
            amount: datas.amount,
            itemCategoryId: datas.itemCategoryId,
            itemCategoryName: datas.itemCategoryName,
            itemServiceId: datas.itemServiceId,
            itemServiceName: datas.itemServiceName,
            remarks: datas.remarks,
          };
          if (this.dialogType == "add") {
            // 判断是否存在
            let flag = false;
            this.CaiWuData.itemServiceReqs.forEach((item) => {
              if (item.itemServiceId == items.itemServiceId) {
                flag = true;
              }
            });

            if (flag) {
              this.$message.warning("该费项已存在");
              return false;
            } else {
              items.operationType = "ADD";
              this.CaiWuData.itemServiceReqs.push(items);

              this.$message.success("添加成功");
            }
          } else {
            //编辑
            let arrs = JSON.parse(
              JSON.stringify(this.CaiWuData.itemServiceReqs)
            );
            // this.CaiWuData.itemServiceReqs.forEach((item, index) => {});
            items.operationType = "UPDATE";
            arrs[this.deitIdx] = items;
            this.CaiWuData.itemServiceReqs = arrs;
          }

          // 动态计算其他费用
          let arrs = [];
          this.CaiWuData.itemServiceReqs.forEach((item) => {
            arrs.push(item.amount);
          });
          this.getOtherExpenses(arrs);
          this.isShowDialog = false;
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    /***
     * 应付
     */
    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2 = {
        // 弹窗表单数据
        amount: "",
        inoutStatus: "zhi_chu:deal_status",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        paymentMethodConfDictId: "",
        remarks: "",
        objectStatusType: "", //对象类型(我自己加的)
        paymentMethod: "", //付款方式名称(我自己加的)
        objectStatus: "", //(我自己加的)
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let objs = JSON.parse(JSON.stringify(this.dialogForm2));
          console.log(objs, "objs");
          if (this.dialogType2 == "add") {
            objs.operationType = "ADD";
            this.financeOutInfoReqs.push(objs);
            this.isShowDialog2 = false;
          } else {
            // editYfIdx
            let arrs = JSON.parse(JSON.stringify(this.financeOutInfoReqs));
            // objs.operationType = "UPDATE";
            arrs[this.editYfIdx] = objs;
            this.financeOutInfoReqs = arrs;
            this.isShowDialog2 = false;
          }
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn2() {
      this.isShowDialog2 = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    /***
     * 收件地址
     */
    handleCloseDia3() {
      this.isShowDialog3 = false;
      this.queryData = {
        customerId: "",
        addressType: "",
        deptName: "",
        personnelName: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn3() {
      // 添加费项
      this.isShowDialog3 = false;
    },

    handleCloseDia_gh() {
      this.isShowDialog_gh = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn_gh() {
      // 添加费项
      this.isShowDialog_gh = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
  },
};
</script>
<style scoped lang='less'>
// 查询条件边框线
@borderColor: #cccccc;

.contentBox {
  padding-bottom: 50px;
}

.infoDiv {
  .h3title {
    background-color: #f2f2f2;
    padding: 10px;
    border-bottom: 1px solid @borderColor;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .formbox {
    padding: 0 30px;

    .jsInput {
      .jsBtns {
        height: 30px;
        line-height: 30px;
        margin: 0;
        padding: 0 10px;
        border: none;
      }
    }
  }

  .goodsItmes {
    margin-top: 30px;
    border-bottom: 4px solid #ccc;
    padding-bottom: 20px;
  }

  .formBtns {
    height: 30px;
    margin: 0;
    padding: 0 10px;
  }

  .miniInput {
    width: 80px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-right: 2px;

    text-align: center;

    /deep/ .el-input__inner {
      text-align: center !important;
      padding: 0 5px;
    }
  }
}

.disFlexs {
  display: flex;
  align-items: center;
  width: 100%;
}

.selectAddress {
  border: 1px solid #ccc;
  margin-right: 10px;
  width: 180px !important;
}
.addressDetails {
  //   width: 380px !important;
  flex: 1;
}

.btmBtns {
  text-align: center;
  margin-top: 50px;

  .saveBtns {
    font-size: 16px;
  }
}

.iconList {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  //   text-align: center;

  .iconSize {
    font-size: 26px;
  }

  .tbBtns {
    padding: 5px 10px;
    margin: 0;
    border: 1px solid #333;
  }
}

.addTiHuoDiZhi {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 20px 0;
}

.multipleSelect {
  display: flex;

  /deep/ .el-select {
    flex: 1;
  }
}

.textArea {
  height: 100%;
}

.glo_btnItems {
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
}

.goodsTable {
  /deep/ .el-table .cell {
    padding-right: 0;
    padding-left: 0;
  }
}

// #tables {
//   .glo_formBox {
//     /deep/ .el-input__icon {
//       line-height: 30px !important;
//     }
//   }
// }
/deep/ .el-input__icon {
  line-height: 30px !important;
}

.disFlex {
  display: flex;
  align-items: center;
}

.tiHuoGuiHua {
  // padding: 0 30px;

  .checkBoxs {
    font-size: 14px;
    margin: 0 0 10px 30px;
  }
}

#tiHuoForm {
  padding: 10px;
  border: 1px dashed @borderColor;
  margin: 0 30px 10px;
}

.renwuList {
  display: flex;
  align-items: center;
  margin-bottom: 50px;

  .btns {
    background-color: #11a265;
    color: #fff;
    border: none;
    margin-right: 50px;
    padding: 10px 20px;
    border-radius: 6px;
  }
  .addBtns {
    background-color: #0390cf;
  }
  .rightBox {
    flex: 1;
    padding: 10px;
    border: 1px dashed #d7d7d7;
    min-height: 160px;
  }
}
</style>